// --- [PATCH: Filter Action Scroll Control] ---
let isFilterAction = false
document.addEventListener("filter:change", () => {
  isFilterAction = true
  window.__applyGutterSpacerNow = true // enable spacer after first filter interaction
})

if (window.quickFilterAlreadyInitialized) {
  // Already initialized, do not run this file again
} else {
  window.quickFilterAlreadyInitialized = true
  // If landing on a clean URL (no query params), clear any persisted quick-filter pills
  // to avoid showing a stale pill like "Massage Guns" by default.
  try {
    if (!window.location.search) {
      localStorage.removeItem("quickFilterOrderArr")
      localStorage.removeItem("quickFilterOrder")
    }
  } catch (_) {}
  window.__alreadyScrolledQuickFilter = false

  window.quickFilterAlreadyInitialized = true
  window.preventQuickScroll = false
  window.suppressNextPillScroll = false
  // Defer gutter spacer on initial page load; enable after first filter change
  // ============================================================================
  // Helpers
  // ============================================================================
  // Waits for quick filter pills to exist in the DOM, then invokes callback (with optional retries)
  function waitForQuickFilters(callback, retries = 10) {
    const quickFiltersExist = document.querySelector(
      ".quick-filter-main .custom-button.selected a",
    )
    if (quickFiltersExist) {
      callback()
    } else if (retries > 0) {
      setTimeout(() => waitForQuickFilters(callback, retries - 1), 100)
    } else {
      callback()
    }
  }

  // Gets the stored quick filter pill order array from localStorage
  function getPillOrderArr() {
    try {
      return JSON.parse(localStorage.getItem("quickFilterOrderArr") || "[]")
    } catch {
      return []
    }
  }
  // Stores the quick filter pill order array to localStorage
  function setPillOrderArr(arr) {
    localStorage.setItem("quickFilterOrderArr", JSON.stringify(arr))
  }
  let quickFilterPillOrder = 0
  // Resets all filters and reloads the page content and filters
  function resetAllFiltersAndReload() {
    // Reset user sort flags when clearing all filters
    window.userManuallySorted = false
    window.userSelectedSort = false

    // Restore active class to "Featured" sort option when clearing filters
    // BUT don't check the radio to prevent it from being included in filters
    const featuredRadio = document.querySelector(
      'input[name="sort_by"][value="manual"]',
    )
    if (featuredRadio) {
      // Don't check the radio - just add active class to show visual selection
      featuredRadio.checked = false

      const featuredLabel = featuredRadio.closest(".mobile-facets__label")
      if (featuredLabel) {
        featuredLabel.classList.add("active")
      }
    }

    const url = new URL(window.location.href)
    url.search = ""
    history.replaceState({}, "", url.pathname)

    // Collapse/remove mobile gutter on Clear
    try {
      window.__applyGutterSpacerNow = false
      const spacer = document.querySelector(".quick-filter-gutter-spacer")
      if (spacer) updateQuickFilterSpacer(spacer, { forceCollapse: true })
    } catch (error) {
      // Error handling for mobile gutter collapse
    }

    if (typeof window.loadContent === "function") {
      window.loadContent()
      checkProductCardsPromoTextHeight()
    } else if (typeof loadContent === "function") {
      loadContent()
      checkProductCardsPromoTextHeight()
    }

    if (typeof window.renderFilters === "function") {
      window.renderFilters()
    } else if (typeof renderFilters === "function") {
      renderFilters()
    }

    if (
      typeof filterSelectionTag !== "undefined" &&
      typeof filterSelectionTag.track === "function"
    ) {
      filterSelectionTag.track()
    }

    // Always scroll to left after clearing for consistent behavior
    if (typeof window.scrollQuickFilterMainLeft === "function") {
      setTimeout(() => {
        window.scrollQuickFilterMainLeft()
      }, 100)
    } else {
      // Fallback: manually scroll the container to the left with proper gutter
      const container = document.querySelector(".quick-filter-main")
      if (container) {
        const mobileGutter = getMobileGutterPx()
        scrollLeftCompat(container, true, mobileGutter)
      }
    }

    // Additional fallback: ensure container is positioned correctly even without pills
    setTimeout(() => {
      const container = document.querySelector(".quick-filter-main")
      if (container) {
        const mobileGutter = getMobileGutterPx()
        scrollLeftCompat(container, true, mobileGutter)
      }
    }, 200)

    // Adjust gap based on pill count after clearing
    if (typeof window.adjustQuickFilterMainGap === "function") {
      window.adjustQuickFilterMainGap()
    } else if (typeof adjustQuickFilterMainGap === "function") {
      adjustQuickFilterMainGap()
    }

    // Fallback: manually clear pills and reset filter state if functions aren't available
    if (
      typeof window.loadContent !== "function" ||
      typeof window.renderFilters !== "function"
    ) {
      // Clear all quick filter pills
      const pillContainer = document.querySelector(".quick-filters-container")
      if (pillContainer) {
        const pills = pillContainer.querySelectorAll(".quick-filter-pill")
        pills.forEach((pill) => pill.remove())
      }

      // Reset any active filter states
      const activeFilters = document.querySelectorAll(
        ".filter-group input:checked, .mobile-facets__checkbox:checked",
      )
      activeFilters.forEach((input) => {
        if (input.type === "radio" && input.value === "manual") {
          // Don't uncheck the Featured sort, just remove checked attribute
          input.removeAttribute("checked")
        } else {
          input.checked = false
        }
      })

      // Update visibility of clear buttons
      if (typeof window.toggleClearFiltersVisibility === "function") {
        window.toggleClearFiltersVisibility()
      }

      // Scroll to left after clearing (even if no pills, this ensures proper positioning)
      if (typeof window.scrollQuickFilterMainLeft === "function") {
        setTimeout(() => {
          window.scrollQuickFilterMainLeft()
        }, 100)
      } else {
        // Fallback: manually scroll the container to the left with proper gutter
        const container = document.querySelector(".quick-filter-main")
        if (container) {
          const mobileGutter = getMobileGutterPx()
          scrollLeftCompat(container, true, mobileGutter)
        }
      }

      // Additional fallback: ensure container is positioned correctly even without pills
      setTimeout(() => {
        const container = document.querySelector(".quick-filter-main")
        if (container) {
          const mobileGutter = getMobileGutterPx()
          scrollLeftCompat(container, true, mobileGutter)
        }
      }, 200)
    }
  }
  window.skipScrollBecauseOfQuickFilterClick = false
  document.addEventListener("mousedown", function (event) {
    const isQuickFilter = event.target.closest(".quick-filter-pill")
    window.skipScrollBecauseOfQuickFilterClick = !!isQuickFilter
  })
  // Scrolls the quick filter container to the left, unless a pill click prevents it
  function tryScrollLeft() {
    if (window.skipScrollBecauseOfQuickFilterClick) {
      window.skipScrollBecauseOfQuickFilterClick = false
      return
    }
    if (window.quickFilterClickPreventScroll) {
      return
    }
    const pillContainer = document.querySelector(".quick-filter-main")
    if (pillContainer) {
      const mobileGutter = getMobileGutterPx()
      scrollLeftCompat(pillContainer, true, mobileGutter)
      requestAnimationFrame(() =>
        scrollLeftCompat(pillContainer, true, mobileGutter),
      )
      setTimeout(() => scrollLeftCompat(pillContainer, true, mobileGutter), 60)
    }
  }
  // Gets the legacy quick filter pill order from localStorage
  function getPillOrder() {
    return JSON.parse(localStorage.getItem("quickFilterOrder") || "[]")
  }
  // Sets the legacy quick filter pill order in localStorage
  function setPillOrder(order) {
    localStorage.setItem("quickFilterOrder", JSON.stringify(order))
  }
  // Builds a unique key for a filter pill
  function getPillKey(key, value) {
    return key + "-" + value
  }
  // Creates a DOM element from an HTML string
  function createElementFromHTML(htmlString) {
    const div = document.createElement("div")
    div.innerHTML = htmlString.trim()
    return div.firstChild
  }
  // Cross-browser scroll-left helper with iOS fallback (ensures left snap on Safari iOS)
  function scrollLeftCompat(el, smooth = true, left = 0) {
    try {
      if (!el) return

      const isIOS =
        /iP(ad|hone|od)/.test(navigator.userAgent) ||
        (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
      const supportsSmooth = "scrollBehavior" in document.documentElement.style
      const target = Math.max(
        0,
        Math.min(left, el.scrollWidth - el.clientWidth),
      )

      if (isIOS) {
        // Multiple assertions to defeat momentum/ignored smooth scroll
        el.scrollLeft = target
        requestAnimationFrame(() => {
          el.scrollLeft = target
        })
        setTimeout(() => {
          el.scrollLeft = target
        }, 60)
      } else if (smooth && supportsSmooth && el.scrollTo) {
        el.scrollTo({ left: target, behavior: "smooth" })
      } else {
        el.scrollLeft = target
      }
    } catch (_) {}
  }

  // Normalizes a filter value for comparison (strips special chars, lowercases, trims)
  function normalizeFilterValue(val) {
    if (typeof val !== "string") return ""
    return val
      .replace(/\+/g, " ")
      .replace(/%20/g, " ")
      .replace(/[^a-zA-Z0-9 ]+/g, "")
      .toLowerCase()
      .trim()
  }
  // Checks if the given filter value matches any quick filter pill in the DOM
  function isQuickFilterMatch(filterValue) {
    const normalized = filterValue.trim().toLowerCase()
    const quickFilterSpans = document.querySelectorAll(".quick-filter-pill")
    for (const span of quickFilterSpans) {
      const label = span.textContent.trim().toLowerCase()
      const dataVal = span
        .getAttribute("data-p")
        ?.split("|")[1]
        ?.trim()
        .toLowerCase()
      if (normalized === label || normalized === dataVal) {
        return true
      }
    }
    return false
  }
  // Creates and appends a quick filter pill to the container, if not already present
  function createQuickFilterPill(
    type,
    value,
    label,
    isMostPopular = false,
    isQuickFilter = false,
    isQuickFilterMatch = true,
  ) {
    if (isMostPopular) return
    const container = document.querySelector(".quick-filters-container")
    if (!container) return
    const existing = container.querySelector(`[data-${type}="${value}"]`)
    if (existing) return
    const pillElement = document.createElement("span")
    pillElement.className = "quick-filter-pill"
    pillElement.setAttribute(`data-${type}`, value)
    pillElement.textContent = label
    if (!pillElement || !(pillElement instanceof Node) || !container) return
    if (pillElement && container) {
      container.appendChild(pillElement)
    }
  }
  // Prevent pill flicker: lock rendering for 200ms after quick filter click
  window.justClickedQuickFilter = false
  window.justClickedQuickFilterTimestamp = null
  // ============================================================================
  // Pill Logic, Event Bindings, AJAX/Product Grid Updates, Drawer Sync, Show More
  // ============================================================================

  // Helper: Scroll quick-filter-main to the leftmost pill
  function scrollQuickFilterMainLeft() {
    const quickFilterMain = document.querySelector(".quick-filter-main")
    if (
      window.preventNextQuickFilterScroll ||
      !quickFilterMain ||
      quickFilterMain.offsetParent === null ||
      quickFilterMain.offsetWidth === 0 ||
      quickFilterMain.offsetHeight === 0
    ) {
      window.preventNextQuickFilterScroll = false
      return
    }
    requestAnimationFrame(() => {
      const mobileGutter = getMobileGutterPx()
      scrollLeftCompat(quickFilterMain, true, mobileGutter)
    })
    window.preventNextQuickFilterScroll = false
  }

  // Mobile breakpoint helper (< 767px)
  function isMobile() {
    try {
      return (
        window.matchMedia && window.matchMedia("(max-width: 767px)").matches
      )
    } catch (_) {
      return (window.innerWidth || 0) < 767
    }
  }

  // Platform helper: Android devices
  function isAndroid() {
    try {
      const ua = navigator.userAgent || ""
      return /Android/i.test(ua)
    } catch (_) {
      return false
    }
  }

  // For left-snap after any filter action on mobile, we rely on CSS padding-left
  // so the correct scrollLeft target is 0 (not the padding value).
  function getMobileGutterPx() {
    if (!isMobile()) return 0
    return 0
  }

  // Ensures the hidden spacer at the start of the pill row keeps the mobile gutter width
  function updateQuickFilterSpacer(spacer, { forceCollapse = false } = {}) {
    if (!spacer) return

    // Hide the spacer entirely when it should not contribute to layout
    if (
      !isMobile() ||
      forceCollapse ||
      window.__applyGutterSpacerNow === false
    ) {
      spacer.style.display = "none"
      spacer.style.width = "0px"
      return
    }

    // Keep spacer collapsed so CSS padding controls the visual gutter
    spacer.style.display = "none"
    spacer.style.width = "0px"
    spacer.style.flexShrink = "0"
  }

  // Main entry point: handles pill logic, event bindings, AJAX loading, drawer sync, and show more
  document.addEventListener("DOMContentLoaded", () => {
    // Make functions globally accessible immediately
    if (typeof getFilters === "function") {
      window.getFilters = getFilters
    }
    if (typeof loadContent === "function") {
      window.loadContent = loadContent
    }
    if (typeof renderFilters === "function") {
      window.renderFilters = renderFilters
    }
    if (typeof toggleClearFiltersVisibility === "function") {
      window.toggleClearFiltersVisibility = toggleClearFiltersVisibility
    }
    if (typeof scrollQuickFilterMainLeft === "function") {
      window.scrollQuickFilterMainLeft = scrollQuickFilterMainLeft
    }
    if (typeof resetAllFiltersAndReload === "function") {
      window.resetAllFiltersAndReload = resetAllFiltersAndReload
    }
    if (typeof adjustQuickFilterMainGap === "function") {
      window.adjustQuickFilterMainGap = adjustQuickFilterMainGap
    }

    // --- [PillCreate] Function to inject unmatched "Most Popular" pills from URL ---
    // Normalizes the label for "Most Popular" filters for comparison
    function normalizeMostPopular(val) {
      return decodeURIComponent(val || "")
        .replace(/\+/g, " ")
        .replace(/%20/g, " ")
        .replace(/\s+/g, " ")
        .replace(/[^a-z0-9 ]+/gi, "")
        .toLowerCase()
        .trim()
    }
    // Injects unmatched "Most Popular" pills from the URL that are checked in the drawer but not present as quick filter buttons
    function createUnmatchedMostPopularPills() {
      // Only run this logic for the "most_popular" filter context
      const params = new URLSearchParams(window.location.search)
      const activeMostPopularFilters =
        params.getAll("filter.p.m.custom.most_popular") || []
      const pillsContainer = document.querySelector(".quick-filters-container")
      if (!pillsContainer) return

      function normalizeMostPopular(val) {
        return decodeURIComponent(val || "")
          .replace(/\+/g, " ")
          .replace(/%20/g, " ")
          .replace(/\s+/g, " ")
          .replace(/[^a-z0-9 ]+/gi, "")
          .toLowerCase()
          .trim()
      }

      activeMostPopularFilters.forEach((label) => {
        if (!label) return
        // Compare filter param values, not just label/text, for language-agnostic deduplication
        const quickBtn = Array.from(
          document.querySelectorAll(".quick-filter-main .custom-button a"),
        ).find((a) => {
          const btnUrl = new URL(a.href, location.origin)
          const btnVal = btnUrl.searchParams.get(
            "filter.p.m.custom.most_popular",
          )
          return (
            btnVal && btnVal.trim().toLowerCase() === label.trim().toLowerCase()
          )
        })
        if (quickBtn && quickBtn.classList.contains("selected")) {
          return
        }
        // Only show pill if option is checked in drawer
        const drawerCheckbox = Array.from(
          document.querySelectorAll(
            'input[name="filter.p.m.custom.most_popular"]',
          ),
        ).find(
          (input) =>
            decodeURIComponent(input.value).trim().toLowerCase() ===
            label.trim().toLowerCase(),
        )
        if (!drawerCheckbox || !drawerCheckbox.checked) return

        // Only create pill if NOT already present (prevents duplication)
        const pillExists = Array.from(
          pillsContainer.querySelectorAll(
            '.quick-filter-pill[data-p^="filter.p.m.custom.most_popular|"]',
          ),
        ).some(
          (pill) =>
            (pill.getAttribute("data-p")?.split("|")[1] || pill.textContent)
              .trim()
              .toLowerCase() === label.trim().toLowerCase(),
        )
        if (pillExists) return

        // Otherwise, create the pill
        const pill = document.createElement("span")
        pill.className = "quick-filter-pill"
        pill.textContent = label
        pill.dataset.p = `filter.p.m.custom.most_popular|${label}`

        pill.addEventListener("click", function () {
          const param = pill.getAttribute("data-p")
          if (param) {
            const [name, value] = param.split("|")
            const urlParams = new URLSearchParams(window.location.search)
            const values = urlParams.getAll(name)
            const newValues = values.filter((v) => v !== value)
            urlParams.delete(name)
            newValues.forEach((v) => urlParams.append(name, v))
            history.replaceState(
              {},
              "",
              `${window.location.pathname}?${urlParams}`,
            )
            if (typeof loadContent2 === "function") {
              loadContent2(
                window.location.pathname + "?" + urlParams.toString(),
              )
            }
          }
        })

        if (pill && pillsContainer) {
          // Insert after the gutter spacer, if present
          const spacer = pillsContainer.querySelector(
            ".quick-filter-gutter-spacer",
          )
          if (spacer && spacer.parentNode === pillsContainer) {
            pillsContainer.insertBefore(pill, spacer.nextSibling)
          } else {
            pillsContainer.insertBefore(pill, pillsContainer.firstChild)
          }
        }
      })
    }
    // [QuickScroll] Setup quick filter pill click handler to set skipScrollBecauseOfQuickFilterClick
    document.querySelectorAll(".quick-filter-pill").forEach((pill) => {
      pill.addEventListener("click", () => {
        skipScrollBecauseOfQuickFilterClick = true
        setTimeout(() => {
          skipScrollBecauseOfQuickFilterClick = false
        }, 1500)
      })
    })
    const quickWrapper = document.querySelector(".quick-filter-main")
    if (!quickWrapper) return

    const drawerSelector = "#FacetFiltersFormMobile, #FacetFiltersForm"
    let drawerForm = document.querySelector(drawerSelector)
    const currency = Shopify.currency?.symbol || "$"
    let userSelectedSort = false
    let userManuallySorted = false

    // Make variables globally accessible for functions outside this scope
    window.userSelectedSort = userSelectedSort
    window.userManuallySorted = userManuallySorted

    const quickContainer = document.createElement("div")
    quickContainer.className = "quick-filters-container"
    // Always append quickContainer safely at the leftmost position
    if (quickWrapper && quickContainer instanceof HTMLElement) {
      quickWrapper.appendChild(quickContainer)
      // Ensure a stable left gutter spacer exists (but keep width 0px on all add/remove per latest request)
      const ensureGutterSpacer = () => {
        try {
          if (!isMobile()) return
          if (!quickContainer.querySelector(".quick-filter-gutter-spacer")) {
            const spacer = document.createElement("span")
            spacer.className = "quick-filter-gutter-spacer"
            spacer.style.flexShrink = "0"
            quickContainer.insertBefore(spacer, quickContainer.firstChild)
            updateQuickFilterSpacer(spacer)
          } else {
            updateQuickFilterSpacer(
              quickContainer.querySelector(".quick-filter-gutter-spacer"),
            )
          }
        } catch (_) {}
      }
      ensureGutterSpacer()
    }

    // --- [REMOVED] Ensure quick filters container uses flex layout and order property ---
    // The pill order is controlled entirely by the JS array (pillOrderArr) and insertion point,
    // not by CSS flex-direction or order. All pills are inserted using
    // quickContainer.insertBefore(pill, quickContainer.firstChild), so the newest pill appears leftmost.

    const clearFilters =
      document.querySelector(".active-facets__button-remove").textContent ||
      "Clear Filters"
    const clearAllBtn = document.createElement("button")
    clearAllBtn.textContent = clearFilters
    clearAllBtn.className =
      "quick-filter-clear-all quick-filter-clear-all-desktop btn-collection-filter button button--tertiary"
    clearAllBtn.style.display = "none"
    quickWrapper.appendChild(clearAllBtn)

    const drawerDetails = document.querySelector(".mobile-facets__disclosure")

    if (drawerDetails) {
      drawerDetails.addEventListener("toggle", () => {
        if (drawerDetails.open) {
          // Reopen all inner <details> inside drawer
          drawerDetails
            .querySelectorAll(".mobile-facets__details")
            .forEach((section) => {
              section.open = true
            })
        }
      })
    }

    // Utility: Debounces a function call (delays execution until after wait ms have elapsed)
    function debounce(func, wait = 300) {
      let timeout
      return (...args) => {
        clearTimeout(timeout)
        timeout = setTimeout(() => func.apply(this, args), wait)
      }
    }

    // Extracts all filter values from both desktop and mobile forms into an object
    function getFilters() {
      const filters = {}
      const forms = [
        document.querySelector("#FacetFiltersForm"),
        document.querySelector("#FacetFiltersFormMobile"),
      ]

      forms.forEach((form) => {
        if (!form) return

        const data = new FormData(form)
        for (const [key, value] of data.entries()) {
          const trimmed = value?.toString().trim()

          if (!trimmed) continue

          const isPriceFilter =
            key === "filter.v.price.gte" || key === "filter.v.price.lte"
          if (isPriceFilter && trimmed === "") continue

          filters[key] = filters[key] || []
          filters[key].push(trimmed)
        }
      })

      // Remove default sort if not explicitly selected
      if (!window.userSelectedSort && filters["sort_by"]?.[0] === "manual") {
        delete filters["sort_by"]
      }

      // Additional safety: remove manual sort if user hasn't explicitly selected it
      if (!window.userManuallySorted && filters["sort_by"]?.[0] === "manual") {
        delete filters["sort_by"]
      }

      // EXTREME PROTECTION: Remove ALL sort_by if user hasn't explicitly selected Featured
      if (!window.userManuallySorted) {
        delete filters["sort_by"]
      }

      // EXTREME PROTECTION: Remove ALL sort_by if sort pill was recently removed
      if (window.__sortPillRemoved) {
        delete filters["sort_by"]
      }

      return filters
    }

    // Converts filter object into a URLSearchParams string, handling arrays and primitives
    function buildCleanParams(params = {}) {
      const cleanParams = new URLSearchParams()

      for (const [key, value] of Object.entries(params)) {
        if (
          typeof value === "string" ||
          typeof value === "number" ||
          typeof value === "boolean"
        ) {
          cleanParams.set(key, value)
        } else if (Array.isArray(value)) {
          for (const val of value) {
            cleanParams.append(key, val)
          }
        }
      }

      return cleanParams.toString()
    }

    // Updates the URL with new filters and triggers AJAX reload of content
    async function updateURL(filters) {
      // Remove default sort unless user clicked a sort radio
      if (!window.userManuallySorted && filters["sort_by"]?.[0] === "manual") {
        delete filters["sort_by"]
      }

      // EXTREME PROTECTION: Remove ALL sort_by if user hasn't explicitly selected Featured
      if (!window.userManuallySorted) {
        delete filters["sort_by"]
      }

      // EXTREME PROTECTION: Remove ALL sort_by if sort pill was recently removed
      if (window.__sortPillRemoved) {
        delete filters["sort_by"]
      }

      const ps = buildCleanParams(filters)
      const newUrl = ps.toString()
        ? `${window.location.pathname}?${ps}`
        : window.location.pathname
      if (filters["sort_by"]?.[0] === "manual") {
        delete filters["sort_by"] // remove default unless user changed it
      }
      history.replaceState({}, "", newUrl)
      loadContent(filters)
    }

    // Extracts available "Most Popular" options from the DOM for button/pill rendering
    function extractLiveMostPopularOptionsFromDOM(container = document) {
      return Array.from(
        container.querySelectorAll(
          'input[name="filter.p.m.custom.most_popular"]',
        ),
      )
        .filter((input) => !input.disabled)
        .map((input) => decodeURIComponent(input.value?.trim() || ""))
    }

    let mostPopularOptionsFromResponse = extractLiveMostPopularOptionsFromDOM()

    // Loads filtered product grid and related UI via AJAX, replaces DOM sections, and rebinds events
    async function loadContent(filters) {
      currentPage = 1
      try {
        // Disable all quick filter pills during loading
        document
          .querySelectorAll(".quick-filter-pill")
          .forEach((pill) => pill.classList.add("disabled"))

        const cleanUrl = `${window.location.pathname}?${buildCleanParams(filters)}`
        const res = await fetch(cleanUrl)
        const html = await res.text()
        const tmp = new DOMParser().parseFromString(html, "text/html")

        // Replace product grid
        const newGrid = tmp.querySelector("#ProductGridContainer")
        const curGrid = document.querySelector("#ProductGridContainer")
        if (newGrid && curGrid) {
          curGrid.innerHTML = newGrid.innerHTML
          if (typeof theme_custom?.percussiveMassageSlider === "function") {
            theme_custom.percussiveMassageSlider()
          }
          // Delay count update to ensure grid has been rendered
          setTimeout(() => {
            const updatedGrid = document.querySelector("#ProductGridContainer")
            const visibleCount =
              updatedGrid?.querySelectorAll(
                "li.grid__item:not(.daily-deals-injected)",
              ).length || 0
            const countElem = document.querySelector(".custom-show-product")
            if (countElem) countElem.textContent = visibleCount.toString()
          }, 0)
        }
        const totalElem = document.querySelector(".custom-total-product")

        const newTotalElem = tmp.querySelector(".custom-total-product")
        if (newTotalElem && totalElem) {
          totalElem.textContent = newTotalElem.textContent
        }

        const progress = document.querySelector(".load-more-progress-bar")
        const countElem = document.querySelector(".custom-show-product")
        if (progress && countElem && totalElem) {
          const total = parseInt(totalElem.textContent || "0")
          const shown = parseInt(countElem.textContent || "0")
          progress.style.width = `${(shown / total) * 100}%`
        }

        // Replace product count
        const newCount = tmp.querySelector(
          "#ProductCount, #ProductCountDesktop",
        )
        const curCount = document.querySelector(
          "#ProductCount, #ProductCountDesktop",
        )
        if (newCount && curCount)
          curCount.innerHTML = newCount.innerHTML.replace(
            "products",
            "Products",
          )

        // Replace drawer filters (mobile) - preserve scroll and avoid full replacement
        const newDrawer = tmp.querySelector("#FacetFiltersFormMobile")
        const curDrawer = document.querySelector("#FacetFiltersFormMobile")
        if (curDrawer && newDrawer) {
          const innerOld = curDrawer.querySelector(".mobile-facets__inner")
          const innerNew = newDrawer.querySelector(".mobile-facets__inner")

          if (innerOld && innerNew) {
            const scrollTop = innerOld.scrollTop

            const mainOld = innerOld.querySelector(".mobile-facets__main")
            const mainNew = innerNew.querySelector(".mobile-facets__main")

            if (mainOld && mainNew) {
              mainOld.innerHTML = mainNew.innerHTML
            }

            setTimeout(() => {
              innerOld.scrollTop = scrollTop
              syncAll() // rebind filters
            }, 0)
          }
        }

        const newDrawerDesktop = tmp.querySelector("#FacetFiltersForm")
        const curDrawerDesktop = document.querySelector("#FacetFiltersForm")
        if (newDrawerDesktop && curDrawerDesktop) {
          const scrollY = curDrawerDesktop.scrollTop
          curDrawerDesktop.replaceWith(newDrawerDesktop)
          newDrawerDesktop.scrollTop = scrollY
        }

        // ✅ Replace .load-more-part after filters are applied
        const newLoadMore = tmp.querySelector(".load-more-part")
        const curLoadMore = document.querySelector(".load-more-part")
        if (newLoadMore && curLoadMore) {
          curLoadMore.replaceWith(newLoadMore.cloneNode(true))
        }

        // Re-extract most popular options
        mostPopularOptionsFromResponse =
          extractLiveMostPopularOptionsFromDOM(tmp)

        // Rebind everything
        syncAll()
        // Re-bind Show More button using global rebind
        setTimeout(() => {
          rebindShowMoreButton()
        }, 0)
        // --- Remove unavailable unmatched Most Popular pills after content load ---
        removeUnavailableUnmatchedPills(html)
        // --- [PATCH] Ensure unmatched Most Popular pills are created after DOM/filter updates ---
        if (typeof createUnmatchedMostPopularPills === "function") {
          requestAnimationFrame(() => {
            setTimeout(() => {
              createUnmatchedMostPopularPills()
              // [PATCH] Ensure pills are cleaned up after all DOM and pill rendering is complete
              setTimeout(removeUnavailableUnmatchedPills, 100)
              checkProductCardsPromoTextHeight()
            }, 100)
          })
        }
        filterSelectionTag.track()
      } catch (e) {
        // Do nothing
      } finally {
        document
          .querySelectorAll(".quick-filter-pill")
          .forEach((pill) => pill.classList.remove("disabled"))
        if (typeof attachMobileClearHandler === "function")
          attachMobileClearHandler()

        document.dispatchEvent(
          new Event("filter:applied", { bubbles: true, composed: true }),
        )
      }
      window.justClickedQuickFilter = false
      window.justClickedQuickFilterTimestamp = null
    }

    // --- Helper to remove unavailable or unmatched Most Popular pills ---
    // Removes unmatched "Most Popular" pills that are no longer available/checked in the drawer
    function removeUnavailableUnmatchedPills() {
      setTimeout(() => {
        const pills = Array.from(
          document.querySelectorAll(
            '.quick-filter-pill[data-p^="filter.p.m.custom.most_popular|"]',
          ),
        )
        let pillRemoved = false
        pills.forEach((pill) => {
          const pillRaw = pill.getAttribute("data-p")?.split("|")[1] || ""
          const normalized = pillRaw
            .replace(/\+/g, " ")
            .replace(/%20/g, " ")
            .replace(/\s+/g, " ")
            .replace(/[^a-z0-9 ]+/gi, "")
            .toLowerCase()
            .trim()
          const drawerCheckbox = Array.from(
            document.querySelectorAll(
              'input[name="filter.p.m.custom.most_popular"]',
            ),
          ).find((input) => {
            return (
              (input.value || "")
                .replace(/\+/g, " ")
                .replace(/%20/g, " ")
                .replace(/\s+/g, " ")
                .replace(/[^a-z0-9 ]+/gi, "")
                .toLowerCase()
                .trim() === normalized
            )
          })
          if (!drawerCheckbox || !drawerCheckbox.checked) {
            pill.remove()
            pillRemoved = true
          }
        })
        // Only scroll left if not suppressed by quick filter click
        if (pillRemoved) {
          if (!window.suppressNextPillScroll) {
            setTimeout(scrollQuickFilterMainLeft, 50)
          }
        }
      }, 50)
    }

    // Sets up price filter input events to sanitize and trigger AJAX updates
    function setupPriceFilters() {
      if (!drawerForm) return

      const priceInputs = [
        drawerForm.querySelector('input[name="filter.v.price.gte"]'),
        drawerForm.querySelector('input[name="filter.v.price.lte"]'),
      ].filter(Boolean)

      priceInputs.forEach((input) => {
        // Clone input to remove problematic event listeners
        const newInput = input.cloneNode(true)
        input.replaceWith(newInput)

        // Store current cursor position
        let cursorPosition = 0

        newInput.addEventListener("keydown", (e) => {
          cursorPosition = e.target.selectionStart
          if (e.key === "Enter") {
            applyPriceFilters()
          }
        })

        newInput.addEventListener("input", (e) => {
          const newValue = e.target.value.replace(/[^0-9]/g, "")
          if (newValue !== e.target.value) {
            e.target.value = newValue
            newInput.setSelectionRange(cursorPosition, cursorPosition)
          }
        })

        newInput.addEventListener("blur", debounce(applyPriceFilters, 300))
      })
    }

    // Clears all sort radio buttons and removes their active states
    function clearSortRadios() {
      // Uncheck all sort radios
      document
        .querySelectorAll('.mobile-facets__checkbox[type="radio"]')
        .forEach((radio) => {
          radio.checked = false
        })
      // Remove active class from labels
      document.querySelectorAll(".mobile-facets__label").forEach((label) => {
        label.classList.remove("active")
      })

      // After clearing, set "Featured" (manual) as the default selected option
      // BUT don't check the radio to prevent it from being included in filters
      const featuredRadio = document.querySelector(
        'input[name="sort_by"][value="manual"]',
      )
      if (featuredRadio) {
        // Don't check the radio - just add active class to show visual selection
        featuredRadio.checked = false

        // Add active class to the Featured label to show it as selected
        const featuredLabel = featuredRadio.closest(".mobile-facets__label")
        if (featuredLabel) {
          featuredLabel.classList.add("active")
        }
      }
    }

    // Rebinds price range input events in <price-range> components to trigger AJAX updates
    function rebindPriceRangeInputs() {
      const priceComponents = document.querySelectorAll("price-range")
      priceComponents.forEach((range) => {
        const minInput = range.querySelector('input[name="filter.v.price.gte"]')
        const maxInput = range.querySelector('input[name="filter.v.price.lte"]')

        if (!minInput || minInput.classList.contains("price-bound")) return

        const updatePrice = () => {
          const filters = getFilters()
          const minVal = minInput.value.trim()
          const maxVal = maxInput.value.trim()

          // Only include valid prices
          if (minVal && !isNaN(minVal)) {
            filters["filter.v.price.gte"] = [minVal]
          } else {
            delete filters["filter.v.price.gte"]
          }

          if (maxVal && !isNaN(maxVal)) {
            filters["filter.v.price.lte"] = [maxVal]
          } else {
            delete filters["filter.v.price.lte"]
          }

          if (minVal || maxVal) {
            updateURL(filters)
          }
        }

        // Blur triggers AJAX update
        minInput.addEventListener("blur", updatePrice)
        maxInput.addEventListener("blur", updatePrice)

        // Enter key
        minInput.addEventListener("keydown", (e) => {
          if (e.key === "Enter") {
            e.preventDefault()
            updatePrice()
          }
        })
        maxInput.addEventListener("keydown", (e) => {
          if (e.key === "Enter") {
            e.preventDefault()
            updatePrice()
          }
        })

        // Prevent instant reload on typing
        minInput.addEventListener("input", (e) => e.stopPropagation())
        maxInput.addEventListener("input", (e) => e.stopPropagation())

        // Mark as bound
        minInput.classList.add("price-bound")
        maxInput.classList.add("price-bound")
      })
    }

    // Removes the 'data-max' attribute from price range inputs to allow any value
    function fixPriceRangeDataMax() {
      document
        .querySelectorAll('price-range input[name="filter.v.price.gte"]')
        .forEach((input) => {
          if (input.hasAttribute("data-max")) {
            input.removeAttribute("data-max") // 🛠 remove limit
          }
        })

      document
        .querySelectorAll('price-range input[name="filter.v.price.lte"]')
        .forEach((input) => {
          if (input.hasAttribute("data-max")) {
            input.removeAttribute("data-max") // 🛠 remove limit
          }
        })
    }

    // Safely binds blur and Enter key events to price inputs to trigger filter updates
    function bindPriceEventsSafely() {
      document
        .querySelectorAll('price-range input[name^="filter.v.price"]')
        .forEach((input) => {
          if (input.classList.contains("price-bound")) return

          input.addEventListener("blur", () => {
            const filters = getFilters()
            updateURL(filters)
          })

          input.addEventListener("keydown", (e) => {
            if (e.key === "Enter") {
              e.preventDefault()
              const filters = getFilters()
              updateURL(filters)
            }
          })

          input.classList.add("price-bound")
        })
    }

    // Binds the drawer clear button to reset filters and trigger AJAX reload
    function setupDrawerClearButton() {
      const drawerClearBtn = document.querySelector(
        ".mobile-facets__clear.button--secondary",
      )

      if (!drawerClearBtn || drawerClearBtn.classList.contains("bound")) return

      drawerClearBtn.addEventListener("click", (e) => {
        e.preventDefault()

        // Reset URL to base collection
        const url = new URL(
          window.location.origin + drawerClearBtn.getAttribute("href"),
        )

        // Wipe filters from the drawer checkboxes
        document
          .querySelectorAll("#FacetFiltersFormMobile input[type='checkbox']")
          .forEach((el) => {
            el.checked = false
          })

        // Clear price inputs if needed
        document
          .querySelectorAll("#FacetFiltersFormMobile input[type='text']")
          .forEach((el) => {
            el.value = ""
          })

        // Trigger AJAX content reload
        loadContent({}) // empty filters

        // Scroll to left after DOM update
        setTimeout(scrollQuickFilterMainLeft, 100)
      })

      drawerClearBtn.classList.add("bound")
    }

    // Rebinds all filter, sort, and price events; syncs UI state; ensures pill and drawer consistency
    function syncAll() {
      // Rebind drawerForm element
      drawerForm = document.querySelector(drawerSelector)

      // Prevent Dawn's default form submission behavior
      document
        .querySelectorAll("#FacetFiltersForm, #FacetFiltersFormMobile")
        .forEach((form) => {
          form.addEventListener("submit", (e) => e.preventDefault())
        })

      // Rebind all checkbox events to submit filters
      if (drawerForm) {
        drawerForm
          .querySelectorAll('input[type="checkbox"]')
          .forEach((input) => {
            if (!input.classList.contains("bound")) {
              input.addEventListener("change", (e) => {
                e.preventDefault()
                e.stopPropagation()
                // --- Matched vs Unmatched behavior for Most Popular ---
                let isMostPopular =
                  e.target.name === "filter.p.m.custom.most_popular"
                if (isMostPopular) {
                  const rawVal = e.target.value || ""
                  // Unified normalization (handles +, %20, slashes, punctuation)
                  const norm = (s) =>
                    decodeURIComponent(s || "")
                      .replace(/\+/g, " ")
                      .replace(/%20/g, " ")
                      .replace(/\s+/g, " ")
                      .replace(/[^a-z0-9 ]+/gi, "")
                      .toLowerCase()
                      .trim()
                  // Does a quick filter button exist for this value?
                  const hasQuickBtn = Array.from(
                    document.querySelectorAll(
                      ".quick-filter-main .custom-button a",
                    ),
                  ).some((a) => {
                    const btnUrl = new URL(a.href, location.origin)
                    const btnVal =
                      btnUrl.searchParams.get(
                        "filter.p.m.custom.most_popular",
                      ) || ""
                    return norm(btnVal) === norm(rawVal)
                  })

                  if (hasQuickBtn && e.target.checked) {
                    // Matched add: scroll to button (handled in renderQuick), no left snap
                    window.justAddedMostPopular = e.target.value
                    window.forceScrollLeftAfterRender = false
                    window.forceScrollLeftValue = null
                    window.blockLeftScrollThisRender = true
                    window.forceScrollPriority = false
                  } else if (hasQuickBtn && !e.target.checked) {
                    // Matched remove: keep current scroll position (no left snap)
                    window.justAddedMostPopular = false
                    window.forceScrollLeftAfterRender = false
                    window.forceScrollLeftValue = null
                    // do not force
                    window.blockLeftScrollThisRender = false
                    window.forceScrollPriority = false
                  } else {
                    // Unmatched add/remove: force left snap
                    window.justAddedMostPopular = false
                    window.forceScrollLeftAfterRender = true
                    window.forceScrollLeftValue = norm(rawVal)
                    window.blockLeftScrollThisRender = false
                    // If this is an unmatched **removal**, make it priority so nothing suppresses it
                    if (!e.target.checked) {
                      window.forceScrollPriority = true
                    } else {
                      window.forceScrollPriority = false
                    }
                  }
                }
                // Always snap left on uncheck/removal from the drawer (any checkbox)
                if (
                  e.target &&
                  e.target.type === "checkbox" &&
                  e.target.checked === false
                ) {
                  const qfm = document.querySelector(".quick-filter-main")
                  const gutter = getMobileGutterPx()
                  window.__quickFilterDesiredLeft = gutter
                  window.forceScrollLeftAfterRender = true
                  window.forceScrollPriority = true
                  window.blockLeftScrollThisRender = false
                }
                window.quickFilterJustAdded = true
                updateURL(getFilters())
                // For non-Most Popular filters, always snap left after render
                if (!isMostPopular) {
                  window.forceScrollLeftAfterRender = true
                  window.forceScrollPriority = true
                  window.blockLeftScrollThisRender = false
                  document.dispatchEvent(new Event("filter:change"))
                }
                // No longer remove pills for checked Most Popular inputs here; handled in removeUnavailableUnmatchedPills.
              })
              input.classList.add("bound")
            }
          })
      }

      // Define and rebind sort_by radios
      function handleSortChange(e) {
        const radio = e.target
        if (!radio || !radio.value) return

        const filters = getFilters()
        filters["sort_by"] = [radio.value]

        window.userSelectedSort = true
        window.userManuallySorted = true
        window.__sortPillRemoved = false // Reset the protection flag when user explicitly selects a sort

        window.quickFilterJustAdded = true
        // Ensure left snap even on iOS after sort selection
        window.forceScrollLeftAfterRender = true
        window.forceScrollPriority = true
        window.blockLeftScrollThisRender = false
        document.dispatchEvent(new Event("filter:change"))
        updateURL(filters)
      }

      const sortRadios = document.querySelectorAll('input[name="sort_by"]')
      sortRadios.forEach((radio) => {
        radio.removeEventListener("change", handleSortChange)
        radio.addEventListener("change", handleSortChange)
      })

      // Rebind price input events (call only once)
      bindPriceEventsSafely()
      rebindPriceRangeInputs()
      setupPriceFilters()
      const filters = getFilters()

      if (drawerForm) {
        drawerForm.querySelectorAll('input[type="checkbox"]').forEach((cb) => {
          cb.checked = !!filters[cb.name]?.includes(cb.value)
        })

        const minInput = drawerForm.querySelector(
          'input[name="filter.v.price.gte"]',
        )
        const maxInput = drawerForm.querySelector(
          'input[name="filter.v.price.lte"]',
        )
        if (minInput) minInput.value = filters["filter.v.price.gte"]?.[0] || ""
        if (maxInput) maxInput.value = filters["filter.v.price.lte"]?.[0] || ""

        // Open all filter accordions
        drawerForm.querySelectorAll("details").forEach((d) => (d.open = true))
      }

      // Sync sort radios
      const urlParams = new URLSearchParams(window.location.search)
      const sortBy = urlParams.get("sort_by")

      document
        .querySelectorAll('.mobile-facets__checkbox[type="radio"]')
        .forEach((radio) => {
          // Special handling for "Featured" (manual) sort: check if explicitly selected OR if it's the default
          if (radio.value === "manual") {
            // Only check the radio if user explicitly selected it
            const shouldCheck = sortBy === "manual" && window.userManuallySorted
            radio.checked = shouldCheck

            const label = radio.closest(".mobile-facets__label")
            if (label) {
              // Show as active if explicitly selected OR if it's the default (no sort selected)
              const shouldShowActive = shouldCheck || !sortBy
              if (shouldShowActive) {
                label.classList.add("active")
              } else {
                label.classList.remove("active")
              }
            }
          } else {
            // Normal handling for other sort options
            const isChecked = radio.value === sortBy
            radio.checked = isChecked

            const label = radio.closest(".mobile-facets__label")
            if (label) {
              if (isChecked && !radio.dataset.default) {
                label.classList.add("active")
              } else {
                label.classList.remove("active")
              }
            }
          }
        })

      // Only retain sort_by in filters if user actually selected it via URL
      // if (!sortBy) {
      //   delete filters["sort_by"]
      // }

      // Ensure "Featured" (manual) sort is never treated as selected unless explicitly chosen
      if (sortBy === "manual" && !window.userManuallySorted) {
        // Remove manual sort from filters to prevent Featured pill creation
        delete filters["sort_by"]
      }

      // Ensure Featured label has active class when it's the default (no sort selected)
      if (!sortBy) {
        const featuredRadio = document.querySelector(
          'input[name="sort_by"][value="manual"]',
        )
        if (featuredRadio) {
          const featuredLabel = featuredRadio.closest(".mobile-facets__label")
          if (featuredLabel) {
            featuredLabel.classList.add("active")
          }
        }
      }

      renderQuick(filters)

      // EXTREME PROTECTION: Remove any "Featured" pills that might have been created
      setTimeout(() => {
        if (!window.userManuallySorted) {
          const featuredPills = document.querySelectorAll(
            '.quick-filter-pill[data-sort-by="manual"]',
          )
          featuredPills.forEach((pill) => pill.remove())
        }
      }, 100)

      // --- [PATCH: Ensure Sort Pill Label Is Always Up To Date After AJAX, Both Radios & Select] ---
      setTimeout(function () {
        const sortByPill = document.querySelector(
          ".quick-filter-pill[data-sort-by]",
        )
        let sortLabel = null
        // Prefer radio label
        const sortRadio = document.querySelector(
          'input[name="sort_by"]:checked',
        )
        if (sortRadio) {
          let labelElem =
            document.querySelector(`label[for="${sortRadio.id}"]`) ||
            sortRadio.closest("label") ||
            sortRadio.parentElement
          if (labelElem) {
            sortLabel = labelElem.textContent.trim()
          }
        } else {
          // Fallback: select box
          const sortSelect = document.querySelector('select[name="sort_by"]')
          if (sortSelect) {
            const selected = sortSelect.querySelector("option:checked")
            if (selected) {
              sortLabel = selected.textContent.trim()
            }
          }
        }
        if (sortByPill && sortLabel) {
          sortByPill.textContent = sortLabel
        }
      }, 80)
      // Removed scrollLeft reset for quick filters container on syncAll
      rebindPriceRangeInputs()
      fixPriceRangeDataMax()
      setupDrawerClearButton()
      document.querySelectorAll('input[name="sort_by"]').forEach((radio) => {
        radio.addEventListener("change", () => {
          window.userSelectedSort = true
        })
        radio.addEventListener("click", () => {
          window.userManuallySorted = true
          window.__sortPillRemoved = false // Reset the protection flag when user explicitly selects a sort
        })
      })
      window.justClickedQuickFilter = false
      window.justClickedQuickFilterTimestamp = null
    }

    // Shows or hides the mobile clear filters button based on active pills
    function toggleMobileClearButton() {
      const clearBtn = document.querySelector(".clear-filters-mobile-only")
      const anyActive =
        document.querySelectorAll(".quick-filter-pill").length > 0
      if (clearBtn) clearBtn.style.display = anyActive ? "flex" : "none"
    }

    // Renders all quick filter pills based on current filters and pill order; updates UI and scrolls as needed
    function renderQuick(filters) {
      // --- [SCROLL PATCH: Separate unmatched Most Popular and quick filter click scroll logic] ---
      // Determine if a scroll should occur for unmatched Most Popular add/remove or quick filter click
      let mostPopularChangedType = null
      if (
        window.forceScrollLeftAfterRender &&
        (!window.blockLeftScrollThisRender || window.forceScrollPriority)
      ) {
        // Branch A: unmatched Most Popular add/remove
        mostPopularChangedType = "unmatched-add"
        if (window.forceScrollPriority) {
          mostPopularChangedType = "unmatched-remove"
        }
      }
      let lastQuickFilterClicked = window._lastQuickFilterClickedValue || null
      // --- Branch A: unmatched Most Popular add/remove scroll ---
      if (
        mostPopularChangedType === "unmatched-add" ||
        mostPopularChangedType === "unmatched-remove"
      ) {
        const quickFilterMain = document.querySelector(".quick-filter-main")
        if (quickFilterMain) {
          const mobileGutter = getMobileGutterPx()
          scrollLeftCompat(quickFilterMain, true, mobileGutter)
        }
        // Reset scroll flags for unmatched Most Popular
        window.forceScrollLeftAfterRender = false
        window.forceScrollLeftValue = null
        window.forceScrollPriority = false
        // Clear quick filter click value to avoid duplicate scroll
        window._lastQuickFilterClickedValue = null
        return
      }
      // --- Branch B: quick filter click scroll ---
      if (lastQuickFilterClicked) {
        const quickFilterMain = document.querySelector(".quick-filter-main")
        if (quickFilterMain) {
          const clickedPill = quickFilterMain.querySelector(
            `[data-filter-value="${lastQuickFilterClicked}"]`,
          )
          if (clickedPill) {
            // Align selected pill left using container's CSS padding-left
            const cs = window.getComputedStyle(quickFilterMain)
            const gutter = parseInt(cs.paddingLeft, 10) || 16
            const maxLeft = Math.max(
              0,
              quickFilterMain.scrollWidth - quickFilterMain.clientWidth,
            )
            const targetLeft = Math.max(
              0,
              Math.min(clickedPill.offsetLeft - gutter, maxLeft),
            )
            quickFilterMain.scrollTo({ left: targetLeft, behavior: "smooth" })
            window._lastQuickFilterClickedValue = null
            return
          }
        }
        window._lastQuickFilterClickedValue = null
      }
      // --- [END PATCH: New scroll branches] ---
      // Remove neighbor scroll logic per latest requirement: keep position on deselect
      window._neighborPillIndexAfterRemoval = null
      // Center the exact quick filter button that was clicked (based on stored key/value)
      if (window._lastQuickFilterClicked) {
        const { key, value } = window._lastQuickFilterClicked
        const quickFilterMain = document.querySelector(".quick-filter-main")
        let targetBtn = null
        if (quickFilterMain) {
          const buttons = quickFilterMain.querySelectorAll(".custom-button a")
          buttons.forEach((a) => {
            if (targetBtn) return
            try {
              const url = new URL(a.href, location.origin)
              const val = url.searchParams.get(key)
              if (val && val.toString() === value.toString()) {
                targetBtn = a
              }
            } catch (_) {}
          })
        }

        if (targetBtn) {
          // Align selected quick filter to the left edge of the container with proper gutter
          const container = document.querySelector(".quick-filter-main")
          if (container) {
            // Get the actual padding-left from CSS
            const computedStyle = window.getComputedStyle(container)
            const paddingLeft = parseInt(computedStyle.paddingLeft, 10) || 0
            const btnLeft = targetBtn.offsetLeft
            const containerWidth = container.clientWidth
            const maxLeft = Math.max(0, container.scrollWidth - containerWidth)
            const targetLeft = Math.max(
              0,
              Math.min(btnLeft - paddingLeft, maxLeft),
            )
            container.scrollTo({ left: targetLeft, behavior: "smooth" })
          } else {
            targetBtn.scrollIntoView({
              inline: "start",
              behavior: "smooth",
              block: "nearest",
            })
          }
        }
        window._lastQuickFilterClicked = null
      }
      // --- [MOVE suppression logic to very top of renderQuick before any DOM or scroll logic] ---
      // Before rendering, collect all current 'Most Popular' pill values
      const quickFilterPillsBefore = document.querySelectorAll(
        '.quick-filter-pill[data-p^="filter.p.m.custom.most_popular|"]',
      )
      const mostPopularValuesBefore = new Set()
      quickFilterPillsBefore.forEach((pill) => {
        let pillValue = pill.getAttribute("data-p").split("|")[1]
        if (pillValue) {
          pillValue = decodeURIComponent(pillValue).trim().toLowerCase()
          mostPopularValuesBefore.add(pillValue)
        }
      })
      let pillOrderArr = getPillOrderArr()
      // --- Early first-time matched Most Popular scroll ---
      if (
        mostPopularValuesBefore &&
        Array.isArray([...mostPopularValuesBefore]) &&
        [...mostPopularValuesBefore].length === 0
      ) {
        // Determine if the newest filter is from Most Popular and matches a quick filter
        const mostPopularParam = filters.find
          ? filters.find((f) => f.paramName === "filter.p.most_popular")
          : null
        if (mostPopularParam) {
          const mpValue = mostPopularParam.value?.toLowerCase()
          const quickBtn = document.querySelector(
            `.quick-filters-container [data-value="${mpValue}"]`,
          )
          if (quickBtn) {
            requestAnimationFrame(() => {
              // Custom scroll that respects padding
              const container = document.querySelector(".quick-filter-main")
              if (container) {
                const computedStyle = window.getComputedStyle(container)
                const paddingLeft = parseInt(computedStyle.paddingLeft, 10) || 0
                const btnLeft = quickBtn.offsetLeft
                const containerWidth = container.clientWidth
                const maxLeft = Math.max(
                  0,
                  container.scrollWidth - containerWidth,
                )
                const targetLeft = Math.max(
                  0,
                  Math.min(btnLeft - paddingLeft, maxLeft),
                )
                container.scrollTo({ left: targetLeft, behavior: "smooth" })
              } else {
                quickBtn.scrollIntoView({
                  behavior: "smooth",
                  inline: "start",
                  block: "nearest",
                })
              }
            })
            window.blockLeftScrollThisRender = true
            window.__suppressNextQuickFilterScroll = true
          }
        }
      }
      // --- End early first-time matched scroll ---
      // Suppress scroll ONLY if the most recently added pill is a Most Popular pill AND it existed before rendering
      let suppressPillScroll = false
      // Forced suppression: if last event was a quick filter click, always suppress scroll
      if (
        window.quickFilterLastEvent &&
        window.quickFilterLastEvent.target &&
        window.quickFilterLastEvent.target.closest(".custom-button a")
      ) {
        suppressPillScroll = true
        window.quickFilterLastEvent = null
      }
      if (
        pillOrderArr.length > 0 &&
        pillOrderArr[0][0] === "filter.p.m.custom.most_popular"
      ) {
        let mostPopularValue = pillOrderArr[0][1]
        mostPopularValue = decodeURIComponent(mostPopularValue)
          .trim()
          .toLowerCase()
        if (mostPopularValuesBefore.has(mostPopularValue)) {
          suppressPillScroll = true
        } else {
        }
      }
      localStorage.removeItem("suppressNextPillScroll") // only use once
      // --- Only after all suppression logic is set, render the pills ---
      if (!mostPopularOptionsFromResponse?.length) {
        mostPopularOptionsFromResponse = extractLiveMostPopularOptionsFromDOM()
      }
      let scrolledOnce = false
      // Prevent flicker/blink when clicking on quick filter: If a quick filter was just clicked, skip full pill rebuild for this event.
      // Strong pill-flicker prevention: skip rendering for 200ms after quick filter click
      if (window.justClickedQuickFilter) {
        if (!window.justClickedQuickFilterTimestamp) {
          window.justClickedQuickFilterTimestamp = Date.now()
        }
        // If within 200ms of click, skip rendering
        if (Date.now() - window.justClickedQuickFilterTimestamp < 200) {
          return
        } else {
          window.justClickedQuickFilter = false
          window.justClickedQuickFilterTimestamp = null
        }
      }

      const prevPillCount = quickContainer.children.length
      // Hide container during rebuild to avoid mid-frame flicker (e.g., Featured pill)
      const __prevVisibility = quickContainer.style.visibility
      quickContainer.style.visibility = "hidden"

      // During clear operations, completely block pill creation to prevent flicker
      if (window.__isClearingFilters) {
        quickContainer.innerHTML = ""
        return // Exit early, don't create any pills during clear
      }

      // Safety: ensure filters object doesn't contain "manual" sort unless explicitly selected
      if (
        filters["sort_by"] &&
        filters["sort_by"][0] === "manual" &&
        !window.userManuallySorted
      ) {
        delete filters["sort_by"]
      }

      // EXTREME SAFETY: Completely remove ALL sort_by from filters if user hasn't explicitly selected Featured
      if (!window.userManuallySorted) {
        delete filters["sort_by"]
      }

      // EXTREME SAFETY: Completely remove ALL sort_by from filters if sort pill was recently removed
      if (window.__sortPillRemoved) {
        delete filters["sort_by"]
      }

      quickContainer.innerHTML = ""
      // --- PATCH: Ensure all active filters are present in pillOrderArr (leftmost is newest) ---
      // --- PATCH: All pills (including sort_by) behave as "newest leftmost" ---
      // 1. Start from pillOrderArr from localStorage
      pillOrderArr = getPillOrderArr()

      // 2. Add any selected filters (including sort_by) not present in pillOrderArr (unshift: leftmost/newest)
      Object.entries(filters).forEach(([key, values]) => {
        if (key.startsWith("filter.v.price")) return

        // EXTREME SAFETY: Never add ANY sort_by entries unless user explicitly selected Featured
        if (key === "sort_by" && !window.userManuallySorted) {
          return
        }

        // EXTREME SAFETY: Never add ANY sort_by entries if sort pill was recently removed
        if (key === "sort_by" && window.__sortPillRemoved) {
          return
        }

        // Only add sort_by pills if NOT default manual, unless the user explicitly selected it
        if (
          key === "sort_by" &&
          (!values || (values[0] === "manual" && !window.userManuallySorted))
        )
          return
        values.forEach((value) => {
          // Extra safety: never add "manual" sort pills unless explicitly selected
          if (
            key === "sort_by" &&
            value === "manual" &&
            !window.userManuallySorted
          ) {
            return
          }
          const exists = pillOrderArr.some(([k, v]) => k === key && v === value)
          if (!exists) {
            pillOrderArr.unshift([key, value])
          }
        })
      })

      // 3. Remove pills no longer selected
      pillOrderArr = pillOrderArr.filter(([key, value]) => {
        if (key === "sort_by") {
          // Only keep if explicitly selected by the user AND not the default "manual" value
          return (
            !!filters["sort_by"] &&
            filters["sort_by"][0] === value &&
            (value !== "manual" || window.userManuallySorted)
          )
        }
        if (key === "price") {
          const min = filters["filter.v.price.gte"]?.[0] || ""
          const max = filters["filter.v.price.lte"]?.[0] || ""
          return value === `${min}_${max}` && (min || max)
        }
        return filters[key]?.includes(value)
      })

      // Additional safety check: remove any "manual" sort pills if user hasn't explicitly selected them
      pillOrderArr = pillOrderArr.filter(([key, value]) => {
        if (
          key === "sort_by" &&
          value === "manual" &&
          !window.userManuallySorted
        ) {
          return false
        }
        return true
      })

      // 4. Save order
      setPillOrderArr(pillOrderArr)

      // Final safety check: ensure no "manual" sort entries exist in pillOrderArr unless explicitly selected
      if (!window.userManuallySorted) {
        pillOrderArr = pillOrderArr.filter(
          ([key, value]) => !(key === "sort_by" && value === "manual"),
        )
        setPillOrderArr(pillOrderArr)
      }

      // EXTREME PROTECTION: Completely remove ALL sort_by entries if user hasn't explicitly selected Featured
      if (!window.userManuallySorted) {
        pillOrderArr = pillOrderArr.filter(([key, value]) => key !== "sort_by")
        setPillOrderArr(pillOrderArr)
      }

      // --- PATCH: Remove duplicate Most Popular entries from pillOrderArr ---
      const seenMostPopular = new Set()
      pillOrderArr = pillOrderArr.filter(([key, value]) => {
        if (key === "filter.p.m.custom.most_popular") {
          const norm = (value || "").trim().toLowerCase()
          if (seenMostPopular.has(norm)) return false // Remove duplicates
          seenMostPopular.add(norm)
        }
        return true
      })

      // --- Sync quick filter button "selected" state to match filters ---
      document
        .querySelectorAll(".quick-filter-main .custom-button a")
        .forEach((a) => {
          const params = new URL(a.href, location.origin).searchParams
          const filterKey = [...params.keys()].find((k) =>
            k.startsWith("filter.p.m.custom.most_popular"),
          )
          if (!filterKey) return
          const filterValue = params.get(filterKey)
          // Mark as selected if this filter/value is active
          a.classList.toggle(
            "selected",
            filters[filterKey]?.includes(filterValue),
          )
        })

      // --- PATCH: Scroll to matched quick filter when Most Popular is selected from drawer ---
      if (
        window.justAddedMostPopular &&
        typeof window.justAddedMostPopular === "string"
      ) {
        const norm = (s) =>
          decodeURIComponent(s || "")
            .replace(/\+/g, " ")
            .replace(/%20/g, " ")
            .replace(/\s+/g, " ")
            .replace(/[^a-z0-9 ]+/gi, "")
            .toLowerCase()
            .trim()

        const matchValue = norm(window.justAddedMostPopular)
        const quickBtn = Array.from(
          document.querySelectorAll(".quick-filter-main .custom-button a"),
        ).find((a) => {
          const btnUrl = new URL(a.href, location.origin)
          const btnVal = btnUrl.searchParams.get(
            "filter.p.m.custom.most_popular",
          )
          return btnVal && norm(btnVal) === matchValue
        })
        if (quickBtn) {
          const container = document.querySelector(".quick-filter-main")

          const getOffsetLeftWithin = (el, ancestor) => {
            let x = 0,
              n = el
            while (n && n !== ancestor) {
              x += n.offsetLeft || 0
              n = n.offsetParent
            }
            return x
          }

          requestAnimationFrame(() => {
            if (container) {
              const cs = window.getComputedStyle(container)
              const paddingLeft = parseInt(cs.paddingLeft, 10) || 16
              const targetLeft = Math.max(
                0,
                getOffsetLeftWithin(quickBtn, container) - paddingLeft,
              )
              const before = container.scrollLeft
              container.scrollTo({ left: targetLeft, behavior: "smooth" })
              setTimeout(() => {
                const after = container.scrollLeft
                const needsRetry = Math.abs(after - targetLeft) > 2
                if (needsRetry) {
                  container.scrollTo({ left: targetLeft, behavior: "auto" })
                }
              }, 60)
              // Prevent any left snap after matched scroll
              window.blockLeftScrollThisRender = true
              window.__suppressNextQuickFilterScroll = true
            }
          })
        }
        // Reset the flag for next render
        window.justAddedMostPopular = false
      }

      // 5. Render: newest at left
      ;[...pillOrderArr].reverse().forEach(([key, value]) => {
        // Insert deduplication/visibility logic for Most Popular before pill creation (NEW LOGIC)
        if (key === "filter.p.m.custom.most_popular") {
          const normalizedValue = value.trim().toLowerCase()
          // PATCH: Removed DOM-based pill duplication check for Most Popular
          // const pillExists = Array.from(
          //   document.querySelectorAll('.quick-filter-pill[data-p^="filter.p.m.custom.most_popular|"]')
          // ).some(
          //   pill =>
          //     (pill.getAttribute("data-p")?.split("|")[1] || pill.textContent)
          //       .trim()
          //       .toLowerCase() === normalizedValue
          // );
          // if (pillExists) return; // Already rendered as pill

          // Skip pill if a custom button already exists and is selected
          const quickBtn = Array.from(
            document.querySelectorAll(".quick-filter-main .custom-button a"),
          ).find((a) => {
            const btnUrl = new URL(a.href, location.origin)
            const btnVal = btnUrl.searchParams.get(
              "filter.p.m.custom.most_popular",
            )
            return btnVal && btnVal.trim().toLowerCase() === normalizedValue
          })
          if (quickBtn && quickBtn.classList.contains("selected")) {
            return
          }

          // Only show pill if option is checked in drawer
          const drawerCheckbox = Array.from(
            document.querySelectorAll(
              'input[name="filter.p.m.custom.most_popular"]',
            ),
          ).find(
            (input) =>
              decodeURIComponent(input.value).trim().toLowerCase() ===
              normalizedValue,
          )
          if (!drawerCheckbox || !drawerCheckbox.checked) return
        }
        let pill, label
        if (key === "sort_by" && !window.__isClearingFilters) {
          // EXTREME PROTECTION: Block ALL sort pill creation if sort pill was recently removed
          if (window.__sortPillRemoved) {
            return // Skip creating ANY sort pill if sort pill was recently removed
          }

          // EXTREME PROTECTION: Block ALL sort pill creation unless user explicitly selected Featured
          if (!window.userManuallySorted) {
            return // Skip creating ANY sort pill if user didn't explicitly select Featured
          }

          // Special handling for "Featured" (manual) sort: only create pill if user explicitly selected it
          if (value === "manual" && !window.userManuallySorted) {
            return // Skip creating Featured pill if user didn't explicitly select it
          }

          // Additional safety: double-check that manual sort is not being processed
          if (value === "manual" && !window.userManuallySorted) {
            return // Extra protection against Featured pill creation
          }

          // Human label for sort
          let sortLabel = value
          const sortRadio = document.querySelector(
            'input[name="sort_by"]:checked',
          )
          if (sortRadio) {
            let labelElem =
              document.querySelector(`label[for="${sortRadio.id}"]`) ||
              sortRadio.closest("label") ||
              sortRadio.parentElement
            if (labelElem) sortLabel = labelElem.textContent.trim()
          } else {
            const sortSelect = document.querySelector('select[name="sort_by"]')
            if (sortSelect) {
              const selected = sortSelect.querySelector("option:checked")
              if (selected) sortLabel = selected.textContent.trim()
            }
          }
          const fallbackSortLabels = {
            "best-selling": "Best Selling",
            "title-ascending": "Alphabetically, A–Z",
            "title-descending": "Alphabetically, Z–A",
            "price-ascending": "Price, Low to High",
            "price-descending": "Price, High to Low",
            "created-descending": "Date, new to old",
            "created-ascending": "Date, old to new",
            manual: "Featured",
          }
          if (!sortLabel || sortLabel === value) {
            sortLabel = fallbackSortLabels[value.toLowerCase()] || value
          }
          pill = document.createElement("span")
          pill.className = "quick-filter-pill"
          pill.textContent = sortLabel
          pill.setAttribute("data-sort-by", value.toLowerCase())
        } else if (key === "price") {
          const [min, max] = value.split("_")
          label = `Price: ${min ? currency + min : ""}${min && max ? " - " : ""}${max ? currency + max : ""}`
          pill = document.createElement("span")
          pill.className = "quick-filter-pill"
          pill.textContent = label
          pill.setAttribute("data-price", "1")
        } else if (key === "filter.p.m.custom.most_popular") {
          pill = document.createElement("span")
          pill.className = "quick-filter-pill"
          pill.textContent = value
          pill.dataset.p = `filter.p.m.custom.most_popular|${value}`
        } else {
          pill = document.createElement("span")
          pill.className = "quick-filter-pill"
          pill.textContent = value
          pill.dataset.p = key + "|" + value
        }
        // Insert every pill at the beginning so newest is always leftmost
        quickContainer.insertBefore(pill, quickContainer.firstChild)
        // [PATCH] Updated universal gutter logic for scroll when filter action triggered
        if (isFilterAction) {
          const isAndroid = /Android/i.test(navigator.userAgent || "")
          const isMobile =
            window.matchMedia && window.matchMedia("(max-width: 767px)").matches
          const isSortPill = pill.hasAttribute("data-sort-by")
          const container = document.querySelector(".quick-filter-main")

          if (container) {
            // Always enforce gutter for all pills
            let gutter = isMobile ? 16 : 40

            // For Android sort pills keep stronger gutter
            if (isAndroid && isMobile && isSortPill) {
              gutter = 16
            }

            const maxLeft = Math.max(
              0,
              container.scrollWidth - container.clientWidth,
            )
            const targetLeft = Math.max(
              0,
              Math.min(pill.offsetLeft - gutter, maxLeft),
            )
            container.scrollTo({ left: targetLeft, behavior: "smooth" })
          }

          isFilterAction = false
        }
      })

      // EXTREME PROTECTION: After all pills are rendered, remove any "Featured" pills if not explicitly selected
      if (!window.userManuallySorted) {
        const featuredPills = document.querySelectorAll(
          '.quick-filter-pill[data-sort-by="manual"]',
        )
        featuredPills.forEach((pill) => pill.remove())
      }
      // [PATCH] After all quick filter pills rendered, add event listeners for quick filter buttons to scroll into view on click
      document
        .querySelectorAll(".quick-filters-container .quick-filter-btn")
        .forEach((btn) => {
          btn.addEventListener("click", () => {
            // Custom scroll that respects padding
            const container = document.querySelector(".quick-filter-main")
            if (container) {
              const btnLeft = btn.offsetLeft
              const containerWidth = container.clientWidth
              const maxLeft = Math.max(
                0,
                container.scrollWidth - containerWidth,
              )

              // Get the current padding-left from CSS
              const computedStyle = window.getComputedStyle(container)
              const paddingLeft = parseInt(computedStyle.paddingLeft, 10) || 0

              const targetLeft = Math.max(
                0,
                Math.min(btnLeft - paddingLeft, maxLeft),
              )
              container.scrollTo({ left: targetLeft, behavior: "smooth" })
            } else {
              btn.scrollIntoView({
                behavior: "smooth",
                block: "nearest",
                inline: "start",
              })
            }
          })
        })
      // --- [NEW SCROLL LOGIC BLOCK] ---
      if (
        !suppressPillScroll &&
        pillOrderArr.length > 0 &&
        pillOrderArr[0][0] === "filter.p.m.custom.most_popular"
      ) {
        let mostPopularValue = decodeURIComponent(pillOrderArr[0][1])
          .trim()
          .toLowerCase()

        // Check if already in pills
        const pillExists = Array.from(
          document.querySelectorAll(
            '.quick-filter-pill[data-p^="filter.p.m.custom.most_popular|"]',
          ),
        ).some(
          (pill) =>
            (pill.getAttribute("data-p")?.split("|")[1] || pill.textContent)
              .trim()
              .toLowerCase() === mostPopularValue,
        )

        // Check if already in selected quick filter button
        const quickBtn = Array.from(
          document.querySelectorAll(
            ".quick-filter-main .custom-button a.selected",
          ),
        ).some((a) => {
          const btnUrl = new URL(a.href, location.origin)
          const btnVal = btnUrl.searchParams.get(
            "filter.p.m.custom.most_popular",
          )
          return btnVal && btnVal.trim().toLowerCase() === mostPopularValue
        })

        if (pillExists || quickBtn) {
          // Block ONLY the default left-snap; allow matched-button scroll to proceed
          window.blockLeftScrollThisRender = true
          // do not return here
        }
      }

      // Scroll as normal if NOT suppressed, and only if a filter was actually just applied
      if (
        !suppressPillScroll &&
        !window.__alreadyScrolledQuickFilter &&
        !window.preventNextQuickFilterScroll &&
        !window.blockLeftScrollThisRender &&
        (window.quickFilterJustAdded || isFilterAction) // quick filter click or any other filter change
      ) {
        const quickContainerElem = document.querySelector(".quick-filter-main")
        if (
          quickContainerElem &&
          quickContainerElem.offsetParent !== null &&
          quickContainerElem.offsetWidth > 0 &&
          quickContainerElem.offsetHeight > 0
        ) {
          // Scenario #2: non-quick filters — always scroll left
          if (isFilterAction) {
            // Use proper mobile gutter to preserve left padding
            const mobileGutter = getMobileGutterPx()
            scrollLeftCompat(quickContainerElem, true, mobileGutter)
            // Prevent a subsequent forced-snap from overriding the gutter
            window.forceScrollLeftAfterRender = false
            isFilterAction = false
            window.__quickFilterDesiredLeft = undefined
          }
          window.__suppressNextQuickFilterScroll = true
          window.__alreadyScrolledQuickFilter = true
          setTimeout(() => {
            window.__alreadyScrolledQuickFilter = false
          }, 150)
        }
      }

      // --- FORCED SCROLL: unmatched Most Popular add/remove should always snap left ---
      if (
        window.forceScrollLeftAfterRender &&
        (!window.blockLeftScrollThisRender || window.forceScrollPriority)
      ) {
        const quickContainerElem = document.querySelector(".quick-filter-main")
        if (
          quickContainerElem &&
          quickContainerElem.offsetParent !== null &&
          quickContainerElem.offsetWidth > 0 &&
          quickContainerElem.offsetHeight > 0
        ) {
          // Forced scenarios must always snap left, with mobile gutter
          const mobileGutter = getMobileGutterPx()
          scrollLeftCompat(quickContainerElem, true, mobileGutter)
          window.__quickFilterDesiredLeft = undefined
          isFilterAction = false
        }
        window.forceScrollLeftAfterRender = false
        window.forceScrollLeftValue = null
        window.forceScrollPriority = false
      }

      // Reset preventQuickScroll flag after all pills are rendered, before any code that uses the flag
      window.preventQuickScroll = false
      window.preventNextQuickFilterScroll = false
      window.blockLeftScrollThisRender = false

      // Re-ensure gutter spacer after DOM changes
      try {
        if (isMobile()) {
          if (!quickContainer.querySelector(".quick-filter-gutter-spacer")) {
            const spacer = document.createElement("span")
            spacer.className = "quick-filter-gutter-spacer"
            spacer.style.flexShrink = "0"
            quickContainer.insertBefore(spacer, quickContainer.firstChild)
            updateQuickFilterSpacer(spacer)
          } else if (!window.__suppressContainerVisibilityToggleNextRender) {
            updateQuickFilterSpacer(
              quickContainer.querySelector(".quick-filter-gutter-spacer"),
            )
          }
        } else {
          const spacer = quickContainer.querySelector(
            ".quick-filter-gutter-spacer",
          )
          if (spacer) spacer.remove()
        }
      } catch (_) {}

      // Show quick filter container only if there is at least one real pill (ignore spacer)
      if (
        !window.__suppressContainerVisibilityToggleNextRender &&
        !window.__isClearingFilters
      ) {
        const pillCountForVisibility =
          quickContainer.querySelectorAll(".quick-filter-pill").length
        if (pillCountForVisibility > 0) {
          quickContainer.style.display = "flex"
        } else {
          quickContainer.style.display = "none"
        }
      }

      // Prevent Featured pill flicker during clear operations
      if (window.__isClearingFilters) {
        const qf = document.querySelector(".quick-filters-container")
        if (qf) {
          qf.style.visibility = ""
          // Force hide during clear to prevent double show/hide
          qf.style.display = "none"
        }
        window.__isClearingFilters = false
      }

      // Additional flicker prevention: suppress container visibility changes during clear
      if (window.__isClearingFilters) {
        window.__suppressContainerVisibilityToggleNextRender = true
      }

      // Removed unconditional scrollLeft/scrollTo after pill rendering (handled per-pill above)
      // Restore visibility after rebuild
      quickContainer.style.visibility = __prevVisibility || ""

      // Always reset the quick filter click flag after rendering completes (not a pill click)
      window.quickFilterClickPreventScroll = false
      // Reset the multiple-custom-block quick filter flag
      window.justClickedMultipleCustomBlockQuickFilter = false
      // Clear one-time suppress flag after render completes
      window.__suppressContainerVisibilityToggleNextRender = false

      // Show/hide Clear All button
      const isRealFilterActive = Object.keys(filters).some((key) => {
        if (key === "sort_by") return false
        const val = filters[key]
        return Array.isArray(val) && val.length > 0
      })
      clearAllBtn.style.display = isRealFilterActive ? "inline-block" : "none"

      // Update custom buttons
      document
        .querySelectorAll(".quick-filter-main .custom-button a")
        .forEach((a) => {
          const params = new URL(a.href).searchParams
          const [key, value] = params.entries().next().value || []
          a.classList.toggle("selected", !!filters[key]?.includes(value))
        })

      // Hide/show quick filter buttons based on active values
      const normalize = (str) =>
        str
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, "-")
          .replace(/^-+|-+$/g, "")
      document
        .querySelectorAll(".quick-filter-main .custom-button a")
        .forEach((btn) => {
          const url = new URL(btn.href)
          const params = url.searchParams
          const filterKey = [...params.keys()].find((k) =>
            k.includes("filter.p.m.custom.most_popular"),
          )
          if (!filterKey) return
          const val = params.get(filterKey)
          const shouldShow = mostPopularOptionsFromResponse.some(
            (opt) => normalize(opt) === normalize(val),
          )
          btn.closest(".custom-button").style.display = shouldShow
            ? "inline-block"
            : "none"
        })

      // Attach mobile clear handler after rendering quick filters
      if (typeof attachMobileClearHandler === "function")
        attachMobileClearHandler()

      // Always reset the quick filter click flag after rendering completes
      window.justClickedQuickFilter = false
      window.justClickedQuickFilterTimestamp = null

      // Adjust gap based on pill count after rendering
      if (typeof window.adjustQuickFilterMainGap === "function") {
        window.adjustQuickFilterMainGap()
      } else if (typeof adjustQuickFilterMainGap === "function") {
        adjustQuickFilterMainGap()
      }
    }

    // Applies price filters from drawer inputs and triggers filter update
    function applyPriceFilters() {
      if (!drawerForm) return

      const minInput = drawerForm.querySelector(
        'input[name="filter.v.price.gte"]',
      )
      const maxInput = drawerForm.querySelector(
        'input[name="filter.v.price.lte"]',
      )
      const min = minInput?.value.trim()
      const max = maxInput?.value.trim()

      const filters = getFilters()

      // Add only if numeric and not empty
      if (min && !isNaN(min)) {
        filters["filter.v.price.gte"] = [min]
      } else {
        delete filters["filter.v.price.gte"]
      }

      if (max && !isNaN(max)) {
        filters["filter.v.price.lte"] = [max]
      } else {
        delete filters["filter.v.price.lte"]
      }

      // Optional validation
      if (min && max && parseFloat(min) > parseFloat(max)) {
        alert("Minimum price cannot be greater than maximum price")
        return
      }

      updateURL(filters)
    }

    // Event handlers
    if (drawerForm) {
      drawerForm.addEventListener("change", (e) => {
        if (!e.target.name) return
        if (!e.target.name.startsWith("filter.v.price")) {
          const isSort = e.target.name === "sort_by"
          const isMostPopular =
            e.target.name === "filter.p.m.custom.most_popular"
          // For all non-quick-filter drawer changes (including sort) that are not matched-MP add,
          // force left snap to be safe on iOS
          if (!isMostPopular) {
            const qfm = document.querySelector(".quick-filter-main")
            const gutter = getMobileGutterPx()
            // Stash desired left padding for render step
            window.__quickFilterDesiredLeft = gutter
            window.forceScrollLeftAfterRender = true
            window.forceScrollPriority = true
            window.blockLeftScrollThisRender = false
          }
          updateURL(getFilters())
          document.dispatchEvent(new Event("filter:change"))
        }
      })
    }

    quickContainer.addEventListener("click", (e) => {
      // Store the event globally for scroll logic
      window.quickFilterLastEvent = e
      const pill = e.target.closest(".quick-filter-pill")
      if (!pill) return
      localStorage.setItem("suppressNextPillScroll", "1")
      window.preventQuickScroll = true

      // Set robust global flag for quick filter pill click
      window.justClickedQuickFilter = true
      // Set scroll-prevent flag for quick filter pill click (legacy)
      window.quickFilterClickPreventScroll = true
      // Set new global skipScrollBecauseOfQuickFilterClick flag
      window.skipScrollBecauseOfQuickFilterClick = true
      setTimeout(() => {
        window.skipScrollBecauseOfQuickFilterClick = false
      }, 1000)

      // Remove neighbor capture logic per latest requirement
      window._neighborPillIndexAfterRemoval = null

      // --- Scroll suppression check BEFORE DOM update ---
      let shouldScroll = true
      if (
        pill &&
        pill.dataset.p &&
        pill.dataset.p.startsWith("filter.p.m.custom.most_popular|")
      ) {
        let value = pill.dataset.p.split("|")[1] || ""
        value = value.trim().toLowerCase().replace(/\+/g, " ")
        // Check for ANY quick filter button with this value
        const quickBtn = Array.from(
          document.querySelectorAll(".quick-filter-main .custom-button a"),
        ).find((a) => {
          const btnUrl = new URL(a.href, location.origin)
          let btnVal = btnUrl.searchParams.get("filter.p.m.custom.most_popular")
          if (!btnVal) return false
          btnVal = btnVal.trim().toLowerCase().replace(/\+/g, " ")
          return btnVal === value
        })
        if (quickBtn) {
          shouldScroll = false
        }
      }
      // Set global flag for next render at the very top
      window.preventNextQuickFilterScroll = !shouldScroll

      const keyValue = pill.dataset.p
      let key, value
      if (keyValue) {
        ;[key, value] = keyValue.split("|")
      } else {
        key = pill.dataset.key
        value = pill.dataset.value
      }

      // --- Uncheck matching drawer input (checkbox/radio) before updating URL/content ---
      // New logic: Use data-p attribute if present, fallback to data-sort-by/data-price logic.
      if (pill.hasAttribute("data-p")) {
        const pillType = pill.getAttribute("data-p").split("|")[0]
        const pillValue = pill.getAttribute("data-p").split("|")[1]
        const drawerInputSelector = `[name="${pillType}"][value="${pillValue}"]`
        const drawerInput = document.querySelector(drawerInputSelector)
        if (drawerInput && drawerInput.checked) {
          drawerInput.click() // Simulate a click to uncheck and trigger change events
        }
      } else if (drawerForm) {
        // Fallback to old logic for legacy pills
        const checkbox = drawerForm.querySelector(
          `input[name="${key}"][value="${value}"]`,
        )
        if (checkbox) {
          checkbox.checked = false
          checkbox.dispatchEvent(new Event("change", { bubbles: true }))
        }
      }

      const filters = getFilters()

      // --- Update pill order array so that the removed/added pill is always leftmost (newest) ---
      let pillOrderArr = getPillOrderArr()
      pillOrderArr = pillOrderArr.filter(
        ([k, v]) => !(k === key && v === value),
      )

      // For sort pills, don't add them back to pillOrderArr when removing
      // For other pills, add them back to maintain order
      if (!pill.hasAttribute("data-sort-by")) {
        pillOrderArr.unshift([key, value])
      }

      setPillOrderArr(pillOrderArr)

      if (pill.hasAttribute("data-sort-by")) {
        // Deselect sort pill: ALWAYS snap left
        delete filters["sort_by"]

        // If removing "Featured" (manual) sort, reset the userManuallySorted flag
        if (value === "manual") {
          window.userManuallySorted = false

          // Also uncheck the "Featured" radio button in the form to prevent it from being re-added
          const featuredRadio = document.querySelector(
            'input[name="sort_by"][value="manual"]',
          )
          if (featuredRadio) {
            featuredRadio.checked = false
          }
        }

        // Additional safety: ensure no sort_by is in filters to prevent Featured pill creation
        delete filters["sort_by"]

        // Also ensure the pillOrderArr doesn't contain any sort_by entries
        let pillOrderArr = getPillOrderArr()
        pillOrderArr = pillOrderArr.filter(([k, v]) => k !== "sort_by")
        setPillOrderArr(pillOrderArr)

        // EXTREME PROTECTION: Set a flag to prevent any sort processing for this session
        window.__sortPillRemoved = true

        const qfm = document.querySelector(".quick-filter-main")
        const gutter = getMobileGutterPx()
        window.__quickFilterDesiredLeft = gutter
        window.forceScrollLeftAfterRender = true
        window.forceScrollPriority = true
        window.blockLeftScrollThisRender = false
        window.preventNextQuickFilterScroll = false
        updateURL(filters)
        setTimeout(() => {
          window.quickFilterClickPreventScroll = false
          window.justClickedQuickFilter = false
          window.skipScrollBecauseOfQuickFilterClick = false
        }, 1000)
        return
      }

      if (pill.hasAttribute("data-price")) {
        // Removing price pill: ALWAYS snap left
        delete filters["filter.v.price.gte"]
        delete filters["filter.v.price.lte"]
        if (drawerForm) {
          drawerForm
            .querySelectorAll('input[name^="filter.v.price"]')
            .forEach((i) => (i.value = ""))
        }
        const qfm = document.querySelector(".quick-filter-main")
        const gutter = getMobileGutterPx()
        window.__quickFilterDesiredLeft = gutter
        window.forceScrollLeftAfterRender = true
        window.forceScrollPriority = true
        window.blockLeftScrollThisRender = false
        window.preventNextQuickFilterScroll = false
      } else {
        if (filters[key]) {
          // Removing any other pill: ALWAYS snap left
          filters[key] = filters[key].filter((v) => v !== value)
          if (!filters[key].length) delete filters[key]
          const qfm = document.querySelector(".quick-filter-main")
          const gutter = getMobileGutterPx()
          window.__quickFilterDesiredLeft = gutter
          window.forceScrollLeftAfterRender = true
          window.forceScrollPriority = true
          window.blockLeftScrollThisRender = false
          window.preventNextQuickFilterScroll = false
        }
      }

      loadContent(filters)

      setTimeout(() => {
        // No scroll on quick filter click, always block scroll here
        window.preventQuickScroll = false
        window.quickFilterClickPreventScroll = false
        window.justClickedQuickFilter = false
        window.skipScrollBecauseOfQuickFilterClick = false
      }, 1000)
      toggleMobileClearButton()
    })

    clearAllBtn.addEventListener("click", () => {
      if (drawerForm) {
        drawerForm
          .querySelectorAll('input[type="checkbox"]')
          .forEach((cb) => (cb.checked = false))
        drawerForm
          .querySelectorAll('input[name^="filter.v.price"]')
          .forEach((i) => (i.value = ""))
      }
      // Reset user sort flags when clearing filters
      window.userManuallySorted = false
      window.userSelectedSort = false

      // Clear sort selection
      clearSortRadios()
      // Clear custom button filters
      document
        .querySelectorAll(".quick-filter-main .custom-button a.selected")
        .forEach((a) => {
          a.classList.remove("selected")
        })

      setPillOrderArr([]) // Clear pill order so no pill is rendered after clearing
      // For Clear Filters: use 16px gutter on mobile for the next render

      // After clearing, ensure gutter spacer is applied on next render
      window.__applyGutterSpacerNow = true
      document.dispatchEvent(new Event("filter:change"))
      updateURL({})
      setTimeout(() => {
        rebindShowMoreButton()
      }, 0)
      // Removed scroll-to-left logic here
    })

    // --- Add logic for .quick-filter-clear-all and .quick-filter-clear-all-mobile buttons ---
    document.querySelectorAll(".quick-filter-clear-all").forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault()

        // Reset user sort flags when clearing filters
        window.userManuallySorted = false
        window.userSelectedSort = false

        const url = new URL(window.location.href)
        const params = url.searchParams
        const preserveParams = ["q", "options[prefix]"]
        const preserved = {}
        preserveParams.forEach((key) => {
          if (params.has(key)) preserved[key] = params.get(key)
        })
        ;[...params.keys()].forEach((key) => {
          if (!preserveParams.includes(key)) params.delete(key)
        })
        Object.keys(preserved).forEach((key) => {
          params.set(key, preserved[key])
        })
        history.pushState({}, "", `${url.pathname}?${params.toString()}`)
        if (typeof renderFilters === "function") {
          renderFilters()
        } else if (
          window.renderFilters &&
          typeof window.renderFilters === "function"
        ) {
          window.renderFilters()
        }
        if (!window.preventQuickScroll) {
          scrollQuickFilterMainLeft()
        }
        window.preventQuickScroll = false
      })
    })

    document
      .querySelectorAll(".quick-filter-main .custom-button a")
      .forEach((a) => {
        // Set the flag on both click and mousedown for best results
        a.addEventListener("mousedown", () => {
          window.justClickedQuickFilter = true
          window.justClickedQuickFilterTimestamp = Date.now()
          // New: set flag to indicate this is a quick filter button click
          window.justClickedMultipleCustomBlockQuickFilter = true
        })
        a.addEventListener("click", async (e) => {
          e.preventDefault()
          // Ensure this is the first statement in the click handler
          localStorage.setItem("suppressNextPillScroll", "1")
          // Store the event globally for scroll logic
          window.quickFilterLastEvent = e
          window.skipScrollOnQuickFilter = true
          // New: set flag to indicate this is a quick filter button click
          window.justClickedMultipleCustomBlockQuickFilter = true
          const params = new URL(a.href).searchParams
          const [key, value] = params.entries().next().value || []

          const filters = getFilters()
          filters[key] = filters[key] || []

          const isDeselection = filters[key].includes(value)

          if (isDeselection) {
            // Deselect: ALWAYS snap left with ~16px gutter (iOS-safe)
            window._lastQuickFilterClicked = null
            filters[key] = filters[key].filter((v) => v !== value)
            const qfm = document.querySelector(".quick-filter-main")
            const gutter = getMobileGutterPx()
            window.__quickFilterDesiredLeft = gutter
            window.forceScrollLeftAfterRender = true
            window.forceScrollPriority = true
            window.blockLeftScrollThisRender = false
            window.preventNextQuickFilterScroll = false
            // Prevent container visibility/spacer toggles this render to avoid flicker
            window.__suppressContainerVisibilityToggleNextRender = true
            // Collapse gutter spacer on deselect
            const spacer = document.querySelector(".quick-filter-gutter-spacer")
            if (spacer) updateQuickFilterSpacer(spacer)
          } else {
            // Selection: remember to center this quick filter button after render
            window._lastQuickFilterClicked = { key, value }
            filters[key].push(value)
          }

          if (!filters[key].length) delete filters[key]

          // Track quick filter pill order for re-add as leftmost (newest)
          let pillOrderArr = getPillOrderArr()
          pillOrderArr = pillOrderArr.filter(
            ([k, v]) => !(k === key && v === value),
          )
          pillOrderArr.unshift([key, value])
          setPillOrderArr(pillOrderArr)

          if (drawerForm) {
            const checkbox = drawerForm.querySelector(
              `input[name="${key}"][value="${value}"]`,
            )
            if (checkbox) checkbox.checked = !!filters[key]?.includes(value)
          }

          // 🔄 Update and reload
          window.quickFilterJustAdded = true
          await updateURL(filters)
          // No scroll-to-left or scrollQuickFilterMainLeft call here!
        })
      })

    // --- [SCROLL PATCH] Scroll clicked quick filter into view after click ---
    // Refactored: Instead of direct scroll here, set a global with the clicked value for renderQuick to handle
    document.addEventListener("click", function (e) {
      const pill = e.target.closest(".quick-filter-main .custom-button a")
      if (pill) {
        const filterValue = pill.getAttribute("data-filter-value")
        if (filterValue) {
          window._lastQuickFilterClickedValue = filterValue
        }
      }
    })

    // Collapse gutter spacer on global clear actions
    document.addEventListener("click", function (e) {
      if (
        e.target.closest(".js-drawer-clear") ||
        e.target.closest(".mobile-facets__clear")
      ) {
        const spacer = document.querySelector(".quick-filter-gutter-spacer")
        if (spacer) updateQuickFilterSpacer(spacer, { forceCollapse: true })
      }
    })

    // Initialize
    setupPriceFilters()
    syncAll()
    // Removed scrollLeft reset for quick filters container on initial load
    // Run clear filters visibility logic once on load
    toggleClearFiltersVisibility()
    // Insert quick filters container positioning
    insertQuickFiltersContainer()
    // Inject clear filters button for mobile
    injectClearFiltersButtonMobile()
    // Enable mobile clear filters binding after button is created
    setTimeout(() => {
      bindMobileClearFilters()
    }, 50)
    // Enable pill container drag scrolling
    const pillContainer = document.querySelector(".quick-filter-main")
    if (pillContainer) {
      let isDown = false
      let startX
      let scrollLeft
      pillContainer.addEventListener("mousedown", (e) => {
        isDown = true
        pillContainer.classList.add("dragging")
        startX = e.pageX - pillContainer.offsetLeft
        scrollLeft = pillContainer.scrollLeft
      })
      pillContainer.addEventListener("mouseleave", () => {
        isDown = false
        pillContainer.classList.remove("dragging")
      })
      pillContainer.addEventListener("mouseup", () => {
        isDown = false
        pillContainer.classList.remove("dragging")
      })
      pillContainer.addEventListener("mousemove", (e) => {
        if (!isDown) return
        e.preventDefault()
        const x = e.pageX - pillContainer.offsetLeft
        const walk = (x - startX) * 1.5
        pillContainer.scrollLeft = scrollLeft - walk
      })
    }
    window.addEventListener("resize", () => {
      if (window.suppressNextPillScroll) return
      const pillContainer = document.querySelector(".quick-filter-main")
      const firstPill = pillContainer?.querySelector(".quick-filter-pill")
      if (pillContainer && firstPill) {
        if (isFilterAction) {
          // Custom scroll that respects padding
          const computedStyle = window.getComputedStyle(pillContainer)
          const paddingLeft = parseInt(computedStyle.paddingLeft, 10) || 0
          const btnLeft = firstPill.offsetLeft
          const containerWidth = pillContainer.clientWidth
          const maxLeft = Math.max(
            0,
            pillContainer.scrollWidth - containerWidth,
          )
          const targetLeft = Math.max(
            0,
            Math.min(btnLeft - paddingLeft, maxLeft),
          )
          pillContainer.scrollTo({ left: targetLeft, behavior: "smooth" })
          isFilterAction = false
        }
      }
    })
  })
  // ============================================================================
  // Clear All, Mobile/Drawer, Utility
  // ============================================================================
  // Injects a clear filters button for mobile view above the filter drawer
  function injectClearFiltersButtonMobile() {
    if (document.querySelector(".quick-filter-clear-all-mobile.in-header"))
      return

    const clearFilters =
      document.querySelector(".active-facets__button-remove").textContent ||
      "Clear Filters"
    const clearBtn = document.createElement("button")
    clearBtn.className =
      "quick-filter-clear-all quick-filter-clear-all-mobile in-header button button--tertiary"
    clearBtn.innerText = clearFilters
    clearBtn.style.display = "none"

    // Event listener is now handled in bindMobileClearFilters() to avoid conflicts and ensure proper blinking prevention
    // Removed backup event listener to prevent duplicate calls

    const mobileDrawer = document.querySelector(
      "menu-drawer.mobile-facets__wrapper",
    )
    if (mobileDrawer && mobileDrawer.parentNode) {
      mobileDrawer.parentNode.insertBefore(clearBtn, mobileDrawer)
    }
  }

  // Overrides price input behavior to trigger AJAX updates on blur/Enter/input
  function overridePriceInputsBehavior(form) {
    if (!form) return
    const minInput = form.querySelector('input[name="filter.v.price.gte"]')
    const maxInput = form.querySelector('input[name="filter.v.price.lte"]')
    const commitPrice = () => {
      const filters = getFilters()
      updateURL(filters)
    }
    if (minInput && !minInput.classList.contains("price-bound")) {
      minInput.addEventListener("input", (e) => e.stopPropagation())
      minInput.addEventListener("blur", commitPrice)
      minInput.addEventListener("keydown", (e) => {
        if (e.key === "Enter") {
          e.preventDefault()
          commitPrice()
        }
      })
      minInput.classList.add("price-bound")
    }
    if (maxInput && !maxInput.classList.contains("price-bound")) {
      maxInput.addEventListener("input", (e) => e.stopPropagation())
      maxInput.addEventListener("blur", commitPrice)
      maxInput.addEventListener("keydown", (e) => {
        if (e.key === "Enter") {
          e.preventDefault()
          commitPrice()
        }
      })
      maxInput.classList.add("price-bound")
    }
  }

  // Shows/hides clear filter buttons based on whether any filters are active (desktop & mobile)
  function toggleClearFiltersVisibility() {
    const urlParams = new URLSearchParams(window.location.search)
    const hasAnyFilter = [...urlParams.keys()].some(
      (key) => key.startsWith("filter.") || key === "sort_by",
    )

    const desktopClear = document.querySelector(
      ".quick-filter-clear-all-desktop",
    )
    const mobileClear = document.querySelector(
      ".quick-filter-clear-all-mobile.in-header",
    )
    const quickClear = document.querySelector(
      ".quick-filter-clear-all:not(.in-header)",
    )

    if (desktopClear) {
      desktopClear.style.display =
        hasAnyFilter && window.innerWidth > 767 ? "inline-block" : "none"
    }

    if (mobileClear) {
      mobileClear.style.display =
        hasAnyFilter && window.innerWidth <= 767 ? "inline-block" : "none"
    }

    if (quickClear) {
      quickClear.style.display =
        window.innerWidth > 767 && hasAnyFilter ? "inline-block" : "none"
    }

    // Adjust gap based on pill count after visibility changes
    if (typeof window.adjustQuickFilterMainGap === "function") {
      window.adjustQuickFilterMainGap()
    } else if (typeof adjustQuickFilterMainGap === "function") {
      adjustQuickFilterMainGap()
    }
  }

  // Adjusts the gap of quick-filter-main based on pill count
  function adjustQuickFilterMainGap() {
    const pillContainer = document.querySelector(".quick-filters-container")
    const mainContainer = document.querySelector(".quick-filter-main")

    if (pillContainer && mainContainer) {
      const pillCount =
        pillContainer.querySelectorAll(".quick-filter-pill").length

      if (pillCount > 0) {
        mainContainer.style.gap = "8px"
      } else {
        mainContainer.style.gap = "0px"
      }
    }
  }

  document.addEventListener("filters:updated", toggleClearFiltersVisibility)
  window.addEventListener("resize", toggleClearFiltersVisibility)
  window.addEventListener("popstate", toggleClearFiltersVisibility)

  const clearFilterObserver = new MutationObserver(() => {
    toggleClearFiltersVisibility()
  })
  clearFilterObserver.observe(document.body, {
    childList: true,
    subtree: true,
  })

  // Binds mobile clear filters button to reset filters, update URL, and re-render pills
  function bindMobileClearFilters() {
    // Try multiple selectors to find the mobile clear button
    const mobileClearBtn =
      document.querySelector(".quick-filter-clear-all-mobile") ||
      document.querySelector(".quick-filter-clear-all-mobile.in-header") ||
      document.querySelector(".quick-filter-clear-all-mobile")

    if (!mobileClearBtn) {
      // Retry after a short delay if button not found
      setTimeout(bindMobileClearFilters, 100)
      return
    }

    mobileClearBtn.addEventListener("click", function (e) {
      e.preventDefault()

      // Use the existing working function instead of duplicating logic
      if (typeof resetAllFiltersAndReload === "function") {
        resetAllFiltersAndReload()
      } else if (typeof window.resetAllFiltersAndReload === "function") {
        window.resetAllFiltersAndReload()
      } else {
        // Fallback: manually implement the clear logic
        window.userManuallySorted = false
        window.userSelectedSort = false

        const url = new URL(window.location.href)
        url.search = ""
        history.replaceState({}, "", url.pathname)

        // Try to call the functions if they exist
        if (typeof window.loadContent === "function") {
          window.loadContent()
        }
        if (typeof window.renderFilters === "function") {
          window.renderFilters()
        }
      }
    })
  }

  document.addEventListener("filters:updated", toggleClearFiltersVisibility)
  document
    .querySelectorAll(".mobile-facets__footer .button--primary")
    .forEach((btn) => {
      btn.addEventListener("click", () => {
        setTimeout(toggleClearFiltersVisibility, 300)
      })
    })

  // Ensures the quick filters container is correctly inserted in the DOM after custom blocks
  function insertQuickFiltersContainer() {
    const container = document.querySelector(".quick-filter-main")
    const target = container?.querySelector(".multiple-custom-block")
    const pillsWrapper = document.querySelector(".quick-filters-container")

    if (pillsWrapper && target && container.contains(target)) {
      container.insertBefore(pillsWrapper, target)
    } else if (pillsWrapper && container) {
      container.appendChild(pillsWrapper)
    }
  }

  // ============================================================================
  // Show More Button Logic
  // ============================================================================
  // Handles AJAX loading and appending of more products when the "Show More" button is clicked
  function handleShowMoreClick(e) {
    e.preventDefault()
    const button = e.currentTarget

    let page = parseInt(button.dataset.page || "2")
    if (!page || isNaN(page)) page = 2

    const baseUrl =
      button.dataset.baseUrl || window.location.pathname.split("?")[0]
    const query = new URLSearchParams(window.location.search)
    query.set("page", page)
    const url = `${baseUrl}?${query.toString()}`

    const grid =
      document.querySelector("#product-grid") ||
      document.querySelector("#ProductGridContainer")
    const countElem = document.querySelector(".custom-show-product")
    const totalElem = document.querySelector(".custom-total-product")
    const progress = document.querySelector(".load-more-progress-bar")
    const spinner = document.querySelector(".load-more-spinner")

    if (countElem && grid) {
      const visibleProducts = grid.querySelectorAll(
        "li.grid__item:not(.daily-deals-injected)",
      )
      countElem.textContent = visibleProducts.length.toString()
    }

    const totalCount = parseInt(totalElem?.textContent || "0")

    button.classList.add("hidden")
    button.dataset.page = (page + 1).toString()
    spinner?.classList.remove("hidden")

    fetch(url)
      .then((res) => res.text())
      .then((html) => {
        const wrapper = document.createElement("div")
        wrapper.innerHTML = html

        const gridWrapper =
          wrapper.querySelector("#product-grid") ||
          wrapper.querySelector("#ProductGridContainer")
        const newItems = gridWrapper
          ? gridWrapper.querySelectorAll(
              "li.grid__item:not(.daily-deals-injected)",
            )
          : []
        // --- Use display count instead of DOM count
        const existingCount = parseInt(countElem?.textContent || "0")
        let appendCount = 0
        newItems.forEach((item) => {
          grid.appendChild(item)
          appendCount++
        })
        if (typeof theme_custom?.percussiveMassageSlider === "function") {
          theme_custom.percussiveMassageSlider()
        }
        // --- After appending, update count based on previous count + new items
        const updatedCount = existingCount + appendCount
        const newTotalElem = wrapper.querySelector(".custom-total-product")
        if (newTotalElem && totalElem)
          totalElem.textContent = newTotalElem.textContent
        if (progress && totalElem) {
          const totalValue = parseInt(totalElem.textContent || "0")
          progress.style.width = `${(updatedCount / totalValue) * 100}%`
        }

        const newLoadMore = wrapper.querySelector(".load-more-part")
        const curLoadMore = document.querySelector(".load-more-part")
        if (newLoadMore && curLoadMore) {
          curLoadMore.replaceWith(newLoadMore.cloneNode(true))
          // Now update the count after DOM replacement so it isn't overwritten
          const newCountElem = document.querySelector(".custom-show-product")
          const newTotalElemAfterReplace = document.querySelector(
            ".custom-total-product",
          )
          if (newCountElem) newCountElem.textContent = updatedCount.toString()
          if (newTotalElemAfterReplace && newTotalElem) {
            newTotalElemAfterReplace.textContent = newTotalElem.textContent
          }
          // Move rebindShowMoreButton call AFTER product cards are appended and inserted into the DOM
          setTimeout(function () {
            if (typeof rebindShowMoreButton === "function") {
              rebindShowMoreButton()
            }
          }, 0)

          // Update next button page from current grid count
          const newButton = document.querySelector(".load-more-btn")
          if (newButton) {
            const itemsPerPage = parseInt(
              document.querySelector(".custom-show-product")?.dataset.perPage ||
                "36",
            )
            const nextPage = Math.ceil(updatedCount / itemsPerPage) + 1
            newButton.dataset.page = nextPage.toString()
          }
        }
        checkProductCardsPromoTextHeight()
      })
      .catch(() => {})
      .finally(() => {
        document.dispatchEvent(
          new Event("more:products:loaded", { bubbles: true, composed: true }),
        )
        spinner?.classList.add("hidden")
      })
  }

  // Rebinds the Show More button click handler after DOM replacement
  function rebindShowMoreButton() {
    const showMoreBtn = document.querySelector(".load-more-btn")
    if (showMoreBtn) {
      showMoreBtn.removeEventListener("click", handleShowMoreClick)
      showMoreBtn.addEventListener("click", handleShowMoreClick)
    }
  }
  window.rebindShowMoreButton = rebindShowMoreButton

  // ============================================================================
  // Miscellaneous/Global Event Handlers
  // ============================================================================
  // Global function assignments moved to DOMContentLoaded for earlier availability
  document.addEventListener("click", function (e) {
    const clearBtn = e.target.closest(".js-drawer-clear")
    if (clearBtn) {
      e.preventDefault()
      const clearURL = clearBtn.getAttribute("href")
      history.pushState({}, "", clearURL)
      // Hide the quick filter container during clear to avoid interim flicker
      try {
        window.__isClearingFilters = true
        const qf = document.querySelector(".quick-filters-container")
        if (qf) qf.style.visibility = "hidden"
      } catch (_) {}

      // Collapse/remove gutter immediately and suppress spacer on next render
      try {
        window.__applyGutterSpacerNow = false
        const spacer = document.querySelector(".quick-filter-gutter-spacer")
        if (spacer) updateQuickFilterSpacer(spacer, { forceCollapse: true })
      } catch (_) {}
      if (
        typeof FacetFiltersForm !== "undefined" &&
        typeof FacetFiltersForm.resetAllFilters === "function"
      ) {
        FacetFiltersForm.resetAllFilters()
      }
      if (typeof loadContent === "function") {
        loadContent(clearURL)
      } else if (typeof renderFilters === "function") {
        renderFilters()
      }
    }
  })

  // Binds the mobile drawer clear button to reset all filters and reload content
  function attachMobileClearHandler() {
    document.querySelectorAll(".mobile-facets__clear").forEach((btn) => {
      btn.removeEventListener("click", resetAllFiltersAndReload) // prevent duplicates
      btn.addEventListener("click", function (e) {
        e.preventDefault()
        resetAllFiltersAndReload()
        setTimeout(scrollQuickFilterMainLeft, 100)
      })
    })
  }

  attachMobileClearHandler()

  document.addEventListener("click", function (e) {
    const isMedia = e.target.closest(".card__media img")
    const isContent = e.target.closest(".card__content.card__content--top")
    const card = e.target.closest(".card[data-prod-url]")
    if (
      (isMedia || isContent) &&
      card &&
      !e.target.closest("a") &&
      !e.target.closest("button")
    ) {
      const url = card.getAttribute("data-prod-url")
      if (url) {
        window.location.href = url
      }
    }
  })
}

// --- [PATCH: Replace scrollIntoView for quick filter pills with custom mobile scroll logic] ---
document.addEventListener(
  "click",
  function (e) {
    const pill = e.target.closest(".quick-filter-pill")
    if (!pill) return

    const container = pill.closest(".quick-filters-container")
    if (!container) return

    const pillRect = pill.getBoundingClientRect()
    const containerRect = container.getBoundingClientRect()

    // Calculate the amount to scroll so pill is fully in view
    const scrollOffset =
      pillRect.left -
      containerRect.left -
      containerRect.width / 2 +
      pillRect.width / 2

    container.scrollTo({
      left: container.scrollLeft + scrollOffset,
      behavior: "smooth",
    })
  },
  true,
)
